import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Expedition 33 All Achievements Expert Glitchless" mdxType="SEO" />
    <h1 {...{
      "id": "clair-obscur-expedition-33-all-achievements-expert-glitchless-route"
    }}>{`Clair Obscur: Expedition 33 All Achievements Expert Glitchless Route`}</h1>
    <hr></hr>
    <h3 {...{
      "id": "notation"
    }}>{`Notation`}</h3>
    <p>{`For menus, I will sometimes have something in parenthesis. If it's (S1-3), it refers to the slot the Picto should be placed in. If it's a Playstation controller button, it's a button you should press to optimize the menu.`}</p>
    <p>{`For battles, there will sometimes be something like (1.1 QTE). This refers to the Quick Time Action you do when you use an Ability. A perfect is 1.2, a normal is 1.1, and a fail is 1.0. The number refers to the damage multiplier the skill gets from the QTE.`}</p>
    <hr></hr>
    <p>{`You can check the changelog at the bottom of the notes.`}</p>
    <p>{`These are my personal notes for the category, the writing will reflect that. For the most part these notes will not say where to go or where things are, just what to do. I will be updating these as the route progresses, changes will be reflected in the changelog at the bottom of the notes.`}</p>
    <p>{`There will also be enemy data and maybe some other useful information at the bottom of the notes.`}</p>
    <p>{`If there's a time listed by a fight, it's my best time for it so far. It does not represent the average.`}</p>
    <h2 {...{
      "id": "prologue"
    }}>{`Prologue`}</h2>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "maelle-450hp-024-027"
      }}>{`Maelle 450HP (0:24-0:27)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1XP, $50, Colour of Lumina`}</p>
      </blockquote>
      <p>{`Option 1: Attack > Parry > Overcharge > Parry > Attack (0:24 w/crit, 0:27 without)`}<br parentName="p"></br>{`
`}{`Option 2: Attack > Parry > Attack > Dodge, Overcharge (0:26). If you get hit instead of dodging add 1 shot.`}</p>
      <p>{`On average, optimal choice is probably to go for Option 2 if you don't get the parry crit T1.`}<br parentName="p"></br>{`
`}{`If you crit an attack with Option 2, you can save 1s by intentionally getting hit by 1 of Maelle's 3 hits.`}</p>
    </Menu>
    <p>{`Fight `}<strong parentName="p">{`Mime`}</strong>{` before going to harbor.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "mime-025"
      }}>{`Mime (0:25)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$50, 1XP, Lumiere`}</p>
      </blockquote>
      <ol>
        <li parentName="ol">{`Attack, Parry 2 Dodge 1 Attack`}</li>
        <li parentName="ol">{`Overcharge`}</li>
        <li parentName="ol">{`4 shots, Attack`}</li>
      </ol>
    </Menu>
    <h3 {...{
      "id": "harbor"
    }}>{`Harbor`}</h3>
    <ul>
      <li parentName="ul">{`Talk to Colette in 3rd booth for `}<strong parentName="li">{`Old Key`}</strong>{`.`}</li>
      <li parentName="ul">{`Talk to Aprentices`}</li>
      <li parentName="ul">{`Talk to Maelle, skip Maelle duel`}</li>
      <li parentName="ul">{`Talk to Emma`}</li>
    </ul>
    <p>{`4 CS on Transition`}</p>
    <h2 {...{
      "id": "act-i"
    }}>{`Act I`}</h2>
    <h3 {...{
      "id": "spring-meadows"
    }}>{`Spring Meadows`}</h3>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "lancelier-122hp-010"
      }}>{`Lancelier 122HP (0:10)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`6XP $50`}</p>
      </blockquote>
      <ul>
        <li parentName="ul">{`Shoot Weak Spot, Attack > Parry`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "portier-450hp-008"
      }}>{`Portier 450HP (0:08)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`10XP, $75, Dodger + 0-2 Chroma Catalyst `}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`You can shoot 2 extra times with Gustave. If he crits the attack, you can then shoot twice with Lune and Immolation to kill.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Shoot weak spot, Attack`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`For the attack party attack, start mashing dodge as soon as his arms touch together. After 3 dodges, parry.`}</p>
      </blockquote>
      <p>{`Parry to kill.`}</p>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Critical Burn`}</strong>{`.`}<br parentName="p"></br>{`
`}{`First strike the Lanceram before the house.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "2-lancelier-240hp-019"
      }}>{`2 Lancelier 240HP (0:19)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`53XP, $144, Lanceram LV1`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Shoot weak spots, Attack`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
      <p>{`Parry.`}</p>
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Attack`}</li>
      </ul>
    </Menu>
    <p>{`You can jump up to the right side before the house, or take the path through the house.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`$360`}</strong>{` in house detour. Pick up `}<strong parentName="p">{`Energy Tint`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "3-volester-81hp-017"
      }}>{`3 Volester 81HP (0:17)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`43XP, $216, 0-2 Chroma Catalyst?`}<br parentName="p"></br>{`
`}{`Parry timing is on slowdown/freeze frames on both of their attacks`}</p>
      </blockquote>
      <p>{`Parry both attacks. Shoot last one to death. Requires 5AP.`}</p>
    </Menu>
    <p>{`After getting `}<strong parentName="p">{`Journal 81`}</strong>{`, tag flag before continuing.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Dead Energy II`}</strong>{`. Afterwards, jump off to the left and menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Lanceram`}</li>
      </ul>
      <h5 {...{
        "id": "pictos"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustav`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`First strike the Abbest on your left.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "2-volester-abbest-009"
      }}>{`2 Volester Abbest (0:09)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$216, 55XP`}<br parentName="p"></br>{`
`}{`If you missed XP earlier, take the fight before Eveque instead. Strat for that fight is in the archive section of these notes.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-1"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Gustav:`}<ul parentName="li">
            <li parentName="ul">{`Shoot each Volester 3 times, don't hit weakness.`}</li>
            <li parentName="ul">{`Shoot Abbest weakness, skip.`}</li>
          </ul></li>
        <li parentName="ul">{`Lune: Ice Lance (1.1)`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Colour of Lumina`}</strong>{` under the bridge.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Resin`}</strong>{`.`}</p>
    <p>{`Go to Flag. `}<strong parentName="p">{`Fast Travel to Abandoned Expeditioner Flag`}</strong><br parentName="p"></br>{`
`}{`Talk to White Nevron. Shoot lamp, talk to Nevron again.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Optionally, Lune equip Lighterim`}</p>
    </blockquote>
    <p>{`Go back to flag again, fast travel to `}<strong parentName="p">{`The Indigo Tree`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: +9 Might (9)`}</li>
        <li parentName="ul">{`Lune: +9 Might (9)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot, Powerful (in that order)`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "eveque-4524hp-204"
      }}>{`Eveque 4524HP (2:04)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`$862, Cleansing Tint, 5 Chroma Catalyst, 0-2 Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: (If Gustave target shoot 1 shield), Powerful`}</li>
        <li parentName="ul">{`Lune: Shoot off shields (last shield shoot weakpoint), Shoot till 3AP, Immolation`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Lune: Immolation`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Shoot till 2AP, Marking Shot`}</li>
        <li parentName="ul">{`Lune: Energising Tint Gustave`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Stop countering Eveque on this turn, until you do the Overcharge.`}<br parentName="p"></br>{`
`}{`Don't kill the Abbests! You need the bonus EXP you get from leaving them alive.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-4"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Overcharge`}</li>
      </ul>
      <p>{`If not dead, shoot off shields and damage as best as you can.`}<br parentName="p"></br>{`
`}{`If it was no crit and Eveque is still healthy, don't counter it's attack so it starts charging up. You can then inflict a good chunk of damage by shooting the core again.`}</p>
    </Menu>
    <h3 {...{
      "id": "continent"
    }}>{`Continent`}</h3>
    <p>{`Go to Camp before entering Flying Waters`}</p>
    <h3 {...{
      "id": "flying-waters"
    }}>{`Flying Waters`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`$333`}</strong>{` along path.`}</p>
    <p>{`Take the detour to the right by the tunnel to spawn 3 Denerim and fight them.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "3-demineur-218hp-004"
      }}>{`3 Demineur 218HP (0:04)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1180XP $399`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-2"
      }}>{`Turn 0`}</h5>
      <p>{`Shoot the 3 bombs`}</p>
    </Menu>
    <p>{`Go to Manor.`}</p>
    <p>{`After getting Maelle menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-1"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Go to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-1"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: +6 Agility (6)`}</li>
        <li parentName="ul">{`Maelle: +15 Might (15)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-1"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
        <li parentName="ul">{`Lune: Wildfire`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "the-curator-hp-024"
      }}>{`The Curator ?HP (0:24)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`720XP, $376`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-3"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Skip`}</li>
        <li parentName="ul">{`Maelle: Offensive Shift`}</li>
        <li parentName="ul">{`Lune: Skip`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
    </Menu>
    <p>{`Talk to Noco and fight him.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "noco-1670hp-022"
      }}>{`Noco 1670HP (0:22)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`486XP $200 `}</p>
      </blockquote>
      <p>{`Offensive Shift > Parry > Percee`}</p>
    </Menu>
    <p>{`Buy `}<strong parentName="p">{`Exposing Attack ($3600)`}</strong>{`. After Noco continue straight.`}<br parentName="p"></br>{`
`}{`Go towards mine for White Demineur, fight the Luster along the way.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "demineur-bruler-luster-014"
      }}>{`Demineur, Bruler, Luster (0:14)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1412XP, $466, Bruleram LV3`}<br parentName="p"></br>{`
`}{`You get ~72 more EXP here by killing Bruler first.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-3"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Shoot Mine, Marking Shot Bruler`}</li>
        <li parentName="ul">{`Lune: Ice Lance Luster (Optional)`}</li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`Shoot Bruler weakspot (kill)`}</li>
            <li parentName="ul">{`Shoot Demineur three times`}</li>
            <li parentName="ul">{`Shoot rest of AP at Luster weakspot, if he lives Attack`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Complete White Demineur quest for `}<strong parentName="p">{`Deminerim`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Recoat`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Talk to Coral Cave Flag`}</p>
    <Menu mdxType="Menu">
      <ul>
        <li parentName="ul">{`Gustav: +4 Might (13), +1 Agility (7)`}</li>
        <li parentName="ul">{`Maelle: +2 Might (17), +1 Agility (1)`}</li>
        <li parentName="ul">{`Lune: +8 Might (17), +4 Agility (4)`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Journal 68`}</strong>{` in thin main pathway.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-1"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Bruleram`}</li>
        <li parentName="ul">{`Lune: Deminerim`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-2"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Exposing Attack`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
        <li parentName="ul">{`Gustav`}<ul parentName="li">
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Dead Energy II`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "goblu-22815hp-137"
      }}>{`Goblu 22815HP (1:37)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`3240XP, $1330, 0-2? Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-4"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Gustav: Powerful`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Can shoot all ATB, Attack`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Gustav: Overcharge`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4-1"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Can shoot all ATB, Attack`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
      <p>{`If still alive, try to setup Marking Shot > Percee again.`}</p>
    </Menu>
    <h3 {...{
      "id": "ancient-sanctuary"
    }}>{`Ancient Sanctuary`}</h3>
    <blockquote>
      <p parentName="blockquote">{`If you've been hitless since getting Maelle, you can use the flag at the start here for Maelle Might. If so, you can skip Powerful vs Robust Sakapatate.`}</p>
    </blockquote>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-2"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lighterim`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "robust-sakapatate-5792hp-039"
      }}>{`Robust Sakapatate 5792HP (0:39)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1824XP, $435, Sakaram Lv.4`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Swings with it's partner: 1 Hit AoE`}</li>
          <li parentName="ul">{`Slams it's shield: 1 Hit AoE, raises Shield and will counter next time its hit.`}</li>
          <li parentName="ul">{`Shield counter: 1 hit AoE, need to dodge sooner than Slams it's shield.`}</li>
          <li parentName="ul">{`Clunky Combo: 2 hit, jump, 1 hit. Has easy audio cue`}</li>
        </ul>
      </blockquote>
      <p>{`Parry his shield attack (prevents him countering later). You can dodge everything else.`}</p>
      <h5 {...{
        "id": "turn-1-5"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation (Fail QTE)`}</li>
        <li parentName="ul">{`Gustav: Powerful`}</li>
        <li parentName="ul">{`Maelle: Swift Strike (Fail QTE)`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-3"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
    </Menu>
    <p>{`Before final right turn, head left and go to path heading slightly downwards for `}<strong parentName="p">{`Journal 63`}</strong>{`.`}</p>
    <p>{`Talk to flag before Ultimate Sakapatate`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-2"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +9 Might (23)`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "ultimate-sakapatate-28236hp-144"
      }}>{`Ultimate Sakapatate 28236HP (1:44)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`8100XP, $1930, Breaker + 3 Polished Catalyst + 0-2 Recoats`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Slams the ground: 1 hit AoE, naturally parry timing.`}</li>
          <li parentName="ul">{`Fires it's Cannons: look for Fire on it's cannons as indicator, parry when you see it.`}</li>
          <li parentName="ul">{`Slams it's shield: 1 hit single target.`}</li>
          <li parentName="ul">{`Combo: 2 hits into jump, dodge the first 2 no point in parrying.`}</li>
          <li parentName="ul">{`Launches weird elecric things: 3 hit single target: Parry once they're top of their arc / flying down.`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-1-6"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Gustav: Powerful`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-4"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Shoot once, then shoot shoulder 3 times to break it. Attack.`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If Gustave doesn't have 5AP, you can Powerful instead, or just Attack.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-3-2"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
        <li parentName="ul">{`Gustav: Overcharge`}</li>
        <li parentName="ul">{`Maelle: Swift Stride`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4-2"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack / Energy Tint Gustave if he has 0 AP.`}</li>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
      <p>{`If still alive, repeat turn 4`}</p>
    </Menu>
    <h3 {...{
      "id": "gestral-village"
    }}>{`Gestral Village`}</h3>
    <p>{`Go to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "learn-skills-2"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Degagement, Rain of Fire`}</li>
      </ul>
    </Menu>
    <p>{`Before starting the tournament, head right and make the first right to pick up `}<strong parentName="p">{`Journal 52`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tournament"
    }}>{`Tournament`}</h3>
    <p>{`Pattern for first 3 fights: Parry, `}<strong parentName="p">{`Degagement`}</strong>{`, Parry, Rain of Fire`}<br parentName="p"></br>{`
`}{`Rewards for each: 2026XP, $366`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "bertrand-big-hands-022"
      }}>{`Bertrand Big Hands (0:22)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Swinging Right Hook x2, Left Uppercut (parry end of windup)`}</p>
      </blockquote>
      <h4 {...{
        "id": "dominique-giant-feet-027"
      }}>{`Dominique Giant Feet (0:27)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Two-handed Ground Pound x2, Right Handed Ground Pound (Parry indicator is his elbow pointing up)`}</p>
      </blockquote>
      <h4 {...{
        "id": "matthieu-the-colossus-023"
      }}>{`Matthieu the Colossus (0:23)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Left Hook x2, Right `}<strong parentName="p">{`Feint`}</strong>{` into Left Uppercut (Parry as he swings)`}</p>
      </blockquote>
      <h4 {...{
        "id": "sciel-3211hp-024"
      }}>{`Sciel 3211HP (0:24)`}</h4>
      <p>{`Parry, Rain of Fire, Parry`}</p>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Sealed Fate: 3 Hit`}</li>
          <li parentName="ul">{`Twilight Slash: 1 Hit`}</li>
          <li parentName="ul">{`Marking Card: 2 hit projectile, Parry as circle closes.`}</li>
        </ul>
      </blockquote>
      <p>{`You need to win vs Sciel for this route.`}</p>
    </Menu>
    <p>{`Talk to Golgra. Then go talk to Jujubree (Merchant).`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`2 Polished Chrome Catalyst - $2000 (6 Total)`}</li>
        <li parentName="ul">{`Critical Moment - $5520`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "camp"
    }}>{`Camp`}</h4>
    <p>{`Sleep. Go to Esquie's Nest. Get `}<strong parentName="p">{`Lost Gestral (1/9)`}</strong>{` outside Esquie's Nest.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-3"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Gustave:`}<ul parentName="li">
            <li parentName="ul">{`+Critical Moment`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "weapons"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Sakaram`}</li>
        <li parentName="ul">{`Maelle: Medalum`}</li>
        <li parentName="ul">{`Lune: Deminerim`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "esquies-nest"
    }}>{`Esquie's Nest`}</h3>
    <p>{`Go to flag by entrance (camp flag might be better?)`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-3"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: +13 Agility (20)`}</li>
        <li parentName="ul">{`Maelle: +9 Might (32)`}</li>
        <li parentName="ul">{`Sciel: +45 Might (45)`}</li>
        <li parentName="ul">{`Lune: +15 Might (29)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-3"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
        <li parentName="ul">{`Lune: Equip Lightning Dance to Bottom Left slot`}</li>
        <li parentName="ul">{`Sciel: `}<strong parentName="li">{`Phantom Blade`}</strong>{`, Intervention`}</li>
        <li parentName="ul">{`Sciel: Equip Intervention to Top Left slot`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "francois-9652hp-018"
      }}>{`Francois 9652HP (0:18)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`2228XP, $392, 345SPD, Augmented First Strike + 0-2 Polished Chroma Catalyst`}</p>
      </blockquote>
      <p>{`Dodge his attacks, use rhythm like Eveque spells`}</p>
      <h5 {...{
        "id": "turn-1-7"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Maelle: Shoot 3 times, Percee`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Better to shoot with Maelle because you don't have to move your aim at all.`}</p>
      </blockquote>
    </Menu>
    <p>{`Backtrack to Esquie. Then take right path to exit, get `}<strong parentName="p">{`Journal 66`}</strong>{` and `}<strong parentName="p">{`Energising Start III`}</strong>{`.`}</p>
    <h3 {...{
      "id": "continent-1"
    }}>{`Continent`}</h3>
    <p>{`Talk to `}<strong parentName="p">{`Lost Gestral`}</strong>{` if you haven't already.`}</p>
    <h4 {...{
      "id": "camp-1"
    }}>{`Camp`}</h4>
    <p>{`Talk to Curator`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Deminerim +4 (7)`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "continent-2"
    }}>{`Continent`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`Energising Start I`}</strong>{` on beach west of `}<strong parentName="p">{`Stone Wave Cliffs`}</strong><br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`$1775`}</strong>{` near Chromatic Bruler.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`$1305`}</strong>{` after breaking the rocks to Stone Wave Cliffs`}</p>
    <h3 {...{
      "id": "stone-wave-cliffs"
    }}>{`Stone Wave Cliffs`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`$790`}</strong>{` on the left before the 1st flag.`}<br parentName="p"></br>{`
`}{`Go towards Delaram. Pick up `}<strong parentName="p">{`Journal 78`}</strong>{`. Pick up `}<strong parentName="p">{`Delaram`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Take left path, pick up `}<strong parentName="p">{`Journal 56`}</strong>{`.`}</p>
    <p>{`Pick up `}<strong parentName="p">{`First Strike`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Energy Tint`}</strong>{` by Paintress Shrine.`}<br parentName="p"></br>{`
`}{`Head left, pick up `}<strong parentName="p">{`Journal 50`}</strong>{`.`}</p>
    <p>{`Pick up `}<strong parentName="p">{`$790`}</strong>{` right of grapple.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`$790`}</strong>{` after Farm flag.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Colour of Lumina`}</strong>{` on path after Farm.`}</p>
    <p>{`Tag `}<strong parentName="p">{`Tide Caverns`}</strong>{` Flag.`}<br parentName="p"></br>{`
`}{`After long grapple down, shoot and pickup `}<strong parentName="p">{`Rock Crystal`}</strong>{` directly in front of you.`}<br parentName="p"></br>{`
`}{`Go left around bend, attack and pick up `}<strong parentName="p">{`Rock Crystal`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go east, jump down towards grapple. Rocher will pop up once you get close to Rock Crystal, Attack it for a preempt.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "rocher-3367hp-011"
      }}>{`Rocher 3367HP (0:11)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1575XP(NB), $316`}</p>
      </blockquote>
      <ul>
        <li parentName="ul">{`Gustav: Marking Shot`}</li>
        <li parentName="ul">{`Lune: Wildfire (fail QTE) `}</li>
        <li parentName="ul">{`Maelle: Percee`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Colour of Lumina`}</strong>{` by right wall.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Colour of Lumina`}</strong>{` before last grapple up.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`-Maelle, +Sciel`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-4"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Augmented First Strike`}</li>
            <li parentName="ul">{`+Breaker`}</li>
            <li parentName="ul">{`+Energising Start I`}</li>
          </ul></li>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+First Strike`}</li>
            <li parentName="ul">{`+Critical Moment`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-1"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
        <li parentName="ul">{`Gustav:`}<ul parentName="li">
            <li parentName="ul">{`-Critical Burn`}</li>
            <li parentName="ul">{`+Exposing Attack`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Dead Energy II`}</li>
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "lampmaster-42677hp-148"
      }}>{`Lampmaster 42677HP (1:48)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`18900XP, $3160, 3 Polished Chroma Catalyst`}<br parentName="p"></br>{`
`}{`Need > 310 speed to outspeed him T2. 312 confirmed working.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Switches off lights and attacks: 4 Lamps launch projectiles. Parry when lamps turn off.`}</li>
          <li parentName="ul">{`Jumps: Parry on landing.`}</li>
          <li parentName="ul">{`Power of its lamps: 1 Dark Attack, visual/audio pre attack cue?`}</li>
          <li parentName="ul">{`Tries to blind: 3 Physical, first swipe is later than it looks.`}</li>
          <li parentName="ul">{`Dark explosion: jumps and hits 1 on landing.`}</li>
        </ul>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`This fight is mostly the same as Any%/Simon%, with a few small changes.`}<br parentName="p"></br>{`
`}{`You now Attack > Ice Lance T1 instead of Ice Lance > Attack`}<br parentName="p"></br>{`
`}{`You are more likely to need 2 parries in P1, since Gustave and Lune are weaker.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-4"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-8"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Energy Tint Sciel`}</li>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-5"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Gustav: Powerful`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <p>{`Enter phase 2.`}</p>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Flying Combo: 4 hits, parry bit after audio cue`}</li>
          <li parentName="ul">{`Attacks with each arm: 4 hits, parry on audio cue?`}</li>
          <li parentName="ul">{`Vast ball of light: Jump, easy timing`}</li>
          <li parentName="ul">{`Sword of light: 1 hit, parry during it's swing at you`}</li>
        </ul>
      </blockquote>
      <p>{`You can dodge both moves, perfect dodge the Sword.`}</p>
      <h5 {...{
        "id": "turn-21"
      }}>{`Turn 2.1`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Energy Tint Lune`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Gustave: Attack`}</li>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "white-haired-man-049"
    }}>{`White-Haired Man (0:49)`}</h4>
    <p>{`Skip turn x4`}</p>
    <h2 {...{
      "id": "act-ii"
    }}>{`Act II`}</h2>
    <p>{`Start off at camp, party full healed. Go to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-4"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +9 Agility (13)`}</li>
        <li parentName="ul">{`Verso: +32 Might (32), +10 Agility (10)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-4"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Marking Shot, `}<strong parentName="li">{`Perfect Recovery`}</strong>{`, Quick Strike, Berserk Slash, Defiant Strike`}</li>
        <li parentName="ul">{`Verso: Equip Defiant Strike to Right-Bottom, Equip Berserk Slash Left-Middle`}</li>
      </ul>
    </Menu>
    <p>{`Do this menu before entering `}<strong parentName="p">{`Forgotten Battlefield`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-3"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Delaram`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-5"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+At Death's Door`}</li>
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`(Triangle) +Energising Start III > Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "forgotten-battlefield"
    }}>{`Forgotten Battlefield`}</h3>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "chevalier-9724hp-024"
      }}>{`Chevalier 9724HP (0:24)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`4134XP (NB), $593, 0-2 Polished Chroma Catalyst`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-9"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Dodge 1st attack`}</li>
        <li parentName="ul">{`Verso: Defiant Strike`}</li>
        <li parentName="ul">{`Let Verso die to Gradient`}</li>
        <li parentName="ul">{`Lune: Skip`}</li>
        <li parentName="ul">{`Maelle: Percee (1.1)`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Journal 41`}</strong>{` to the right of Clea.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Journal 57`}</strong>{` on the way to Inverted.`}</p>
    <p>{`Buy `}<strong parentName="p">{`Inverted Affinity - $9870`}</strong>{` from Merchant.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-6"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Inverted Affinity`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-2"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`-Exposing Attack`}</li>
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul">{`+Critical Moment`}</li>
            <li parentName="ul">{`+Dodger`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "formation-1"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`-Maelle, +Sciel`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "dualliste-71106hp-140215"
      }}>{`Dualliste 71106HP (1:40/2:15)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`33072XP, $3950, Dualiso + Combo Attack I + 3 Polished Chroma Catalyst + 0-1 Recoat?`}<br parentName="p"></br>{`
`}{`Threshold between him getting 2 attacks before you is somewhere between 328 and 318 speed.`}</p>
      </blockquote>
      <p>{`Good or bad fight depends on targetting, bad fight loses ~30s.`}<br parentName="p"></br>{`
`}{`1st phase you need Sciel or Verso. 2nd phase you NEED Verso target at the start. If you don't get the right moves turn 1, you can refer to mediocre fight below.`}</p>
      <h5 {...{
        "id": "turn-0-5"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Note that if you hit all crits and he targets Verso with the jump attack move, you can kill off the first Berserk Slash.`}<br parentName="p"></br>{`
`}{`If that happens, you Immolation T1. After the transition, Intervention > Berserk Slash, and next turn Lune Tint Sciel, Berserk Slash > Intervention > Berserk Slash. You don't need to counter his moves in phase 2.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-10"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Energy Tint Verso / Immolation`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Intervention Verso`}</li>
        <li parentName="ul">{`Verso: Defiant Strike / Berserk Slash`}</li>
      </ul>
      <p>{`Phase transitions here. `}<strong parentName="p">{`Notation is good / bad fight`}</strong>{`. Good fight is ONLY if Verso is targeted on his 1st attack.`}<br parentName="p"></br>{`
`}{`If good fight, parry everything. If not, dodge everything, you want to do less than half his HP on this turn.`}</p>
      <h5 {...{
        "id": "turn-2-6"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack or Tint Sciel / Skip`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Intervention Verso > Berserk Slash / Tint if needed, else nothing`}</li>
      </ul>
      <p>{`Good fight kills here.`}</p>
      <h5 {...{
        "id": "turn-3-4"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Intervention Verso`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`This is an alternate strat, that can't get as good of a time, but is also faster than the above in bad cases. I recommend this variant if you get Lune target or AoE for Dualliste's 1st attack.`}</p>
      </blockquote>
      <h4 {...{
        "id": "mediocre-fight-200"
      }}>{`Mediocre Fight (2:00)`}</h4>
      <h5 {...{
        "id": "turn-1-11"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Tint Verso`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Attack`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If you can transition with a parry, go for it.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-2-7"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Tint Verso / Nothing`}</li>
        <li parentName="ul">{`Verso: Berserk Slash / Defiant Strike`}</li>
      </ul>
      <p>{`Phase change. Don't counter him this phase with this fight version, unless you transitioned off a parry and it's Verso target. In that case, play like the good fight 2nd phase.`}</p>
      <h5 {...{
        "id": "turn-21-1"
      }}>{`Turn 2.1`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Intervention Verso`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
      <p>{`Parry + Dodge AoE for AP generation.`}</p>
      <h5 {...{
        "id": "turn-3-5"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Attack / Skip (Skip saves ~4s)`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Sciel: Intervention Verso`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "camp-2"
    }}>{`Camp`}</h3>
    <p>{`Go to Curator`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons-1"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Deminerim +2 (9)`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-resources"
      }}>{`Upgrade Resources`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +2 Lumina (18)`}</li>
        <li parentName="ul">{`Sciel: +2 Lumina (20)`}</li>
      </ul>
    </Menu>
    <p>{`Option 2 to sleep.`}</p>
    <h3 {...{
      "id": "continent-3"
    }}>{`Continent`}</h3>
    <p>{`Fight group before Monoco Station`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "demineur-troubador-gault-015"
      }}>{`Demineur, Troubador, Gault (0:15)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`6890XP (NB), $988, Troubadim LV8 + Gaulteram LV8 + 0-1? Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-6"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: `}<ul parentName="li">
            <li parentName="ul">{`Shoot Mine then shoot Demineur 2 times.`}</li>
            <li parentName="ul">{`Defiant Strike Troubador`}</li>
          </ul></li>
        <li parentName="ul">{`Lune: Wildfire (Fail QTE)`}</li>
        <li parentName="ul">{`Sciel: Phantom Blade Gault`}</li>
      </ul>
    </Menu>
    <p>{`Menu before Monoco.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-4"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Dualiso`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-7"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Combo Attack > At Death's Door `}</li>
            <li parentName="ul">{`+Critical Moment > First Strike (Swap)`}</li>
            <li parentName="ul">{`+Exposing Attack > Inverted Affinity (Swap)`}</li>
          </ul></li>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+At Death's Door`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-3"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Critical Moment`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "monoco-station"
    }}>{`Monoco Station`}</h3>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "monoco-111599hp-030"
      }}>{`Monoco 111599HP (0:30)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`54000XP, $4360, 3 Polished Chroma Catalyst + 0-1 Recoat. Speed between 346-349`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-7"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Immolation `}</li>
      </ul>
      <p>{`Dodge his Attack`}</p>
      <h5 {...{
        "id": "turn-1-12"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Energy Tint Lune`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Menu>
    <p>{`Menu before Stalact.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "lumina-4"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`(R3) +First Strike`}</li>
            <li parentName="ul">{`-Dodger`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "stalact-51507hp-046"
      }}>{`Stalact 51507HP (0:46)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`21600XP, $1744, Polished Chroma Catalyst + 0-1 Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-8"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Ice Lance (Fail QTE)`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Gradient > Lightning Dance`}</li>
      </ul>
    </Menu>
    <p>{`After Stalact back track to the flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-5"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul"><strong parentName="li">{`If Recoat:`}</strong>{` Lune: Recoat, +14 Might, +37 Agility, +9 Luck (If short cut 3 Might)`}</li>
        <li parentName="ul">{`Verso: +18 Agility (28)`}</li>
        <li parentName="ul">{`Maelle: +18 Might (53)`}</li>
        <li parentName="ul">{`Monoco: +78 Agility (78)`}</li>
        <li parentName="ul">{`Sciel: +4 Might (49), +5 Agility (5), +9 Luck (9)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-5"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +Mayhem, +Elemental Trick`}</li>
        <li parentName="ul">{`Lune: Equip Elemental Trick Top-Left`}</li>
        <li parentName="ul">{`Verso: +Powerful, +Leadership`}</li>
        <li parentName="ul">{`Verso: Equip Leadership Left-Top, Powerful Left-Bottom`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Journal 65`}</strong>{`. Then fall down to the left to warp, turn around, and exit towards `}<strong parentName="p">{`Old Lumiere`}</strong>{`.`}</p>
    <h3 {...{
      "id": "old-lumiere"
    }}>{`Old Lumiere`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-8"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune`}<ul parentName="li">
            <li parentName="ul">{`+Energising Start I > First Strike (No Swap)`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-5"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune: `}<ul parentName="li">
            <li parentName="ul">{`-Dodger`}</li>
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`-Critical Burn`}</li>
            <li parentName="ul">{`-Dodger`}</li>
            <li parentName="ul">{`+First Strike`}</li>
            <li parentName="ul">{`+Inverted Affinity`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle: `}<ul parentName="li">
            <li parentName="ul">{`(R3) +Inverted Affinity`}</li>
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Monoco:`}<ul parentName="li">
            <li parentName="ul">{`+Inverted Affinity`}</li>
            <li parentName="ul">{`+First Strike`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Inverted Affinity`}</li>
            <li parentName="ul">{`+Energising Start I`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "verso--maelle-section"
    }}>{`Verso & Maelle section`}</h4>
    <p>{`After going through doorway, go right and pick up `}<strong parentName="p">{`Journal Survivor`}</strong>{` and `}<strong parentName="p">{`Polished Chroma Crystal`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "chevaliers-010"
      }}>{`Chevaliers (0:10)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`13662XP, $998, Battlum LV10 + 0-2 Polished Chroma Catalyst`}<br parentName="p"></br>{`
`}{`Verso outspeeds at 522 speed, 521 might work.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-9"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Rain of Fire`}</li>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
      </ul>
    </Menu>
    <p>{`Go to Manor. Pick up `}<strong parentName="p">{`Renoir`}</strong>{` and `}<strong parentName="p">{`Journal Renoir`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "renoir-140186hp-050"
      }}>{`Renoir 140186HP (0:50)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`51750XP (NB), $4990, Melarum + 3 Polished Chroma Catalyst + 0-2 Recoat`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Massive amount of chroma: Gradient once he jumps into the air.`}</li>
          <li parentName="ul">{`Melee combo: 5, 4th hit is later than it looks.`}</li>
          <li parentName="ul">{`Giant pool of chroma: jump`}</li>
          <li parentName="ul">{`Attacks from a distance: 4 hit, look for slowdown.`}</li>
          <li parentName="ul">{`Vanish an expeditioner: Gradient before he strikes black orb.`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-1-13"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Rain of Fire`}</li>
        <li parentName="ul">{`Lune: Wildfire fail QTE`}</li>
        <li parentName="ul">{`Verso: Powerful`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-8"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Energy Tint Lune`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
        <li parentName="ul">{`Maelle: Healing Tonic Lune if she didn't crit herself / nothing / offensive shift`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-6"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Leadership/Tonic. If you did Offensive Shift can just do the Leadership/Tonic`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Menu>
    <blockquote>
      <p parentName="blockquote">{`Have $17409 right here, with completely standard money route (no re-entrance into Lumiere)`}</p>
    </blockquote>
    <h3 {...{
      "id": "continent-4"
    }}>{`Continent`}</h3>
    <p>{`After Camp, re-enter `}<strong parentName="p">{`Old Lumiere`}</strong></p>
    <h3 {...{
      "id": "old-lumiere-1"
    }}>{`Old Lumiere`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`$4990`}</strong>{` and `}<strong parentName="p">{`Journal 42`}</strong>{`. Flag, back to continent.`}</p>
    <h3 {...{
      "id": "visages"
    }}>{`Visages`}</h3>
    <p><strong parentName="p">{`Talk to the Plazza Flag`}</strong>{`. `}</p>
    <h4 {...{
      "id": "sadness-vale"
    }}>{`Sadness Vale`}</h4>
    <p>{`Pick up `}<strong parentName="p">{`Glass Cannon`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Resplendent Chroma Catalyst`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go north east, at fork go right and jump up ledge. Pick up `}<strong parentName="p">{`Journal 39`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go back to flag and fast travel back to `}<strong parentName="p">{`Plazza`}</strong>{`.`}</p>
    <h4 {...{
      "id": "joy-vale"
    }}>{`Joy Vale`}</h4>
    <p>{`Pick up `}<strong parentName="p">{`Confident Fighter`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-2"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`-Lune, +Lune, -Maelle, +`}<strong parentName="li">{`Monoco`}</strong></li>
      </ul>
      <h5 {...{
        "id": "pictos-9"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Monoco:`}<ul parentName="li">
            <li parentName="ul">{`+Glass Cannon`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Combo Attack`}</li>
          </ul></li>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Confident Fighter > At Death's Door`}</li>
            <li parentName="ul">{`+First Strike > Energising Start`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-6"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Energising Start I`}</li>
            <li parentName="ul">{`(R3) +At Death's Door`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+At Death's Door`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "weapons-1"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Delaram`}</li>
      </ul>
    </Menu>
    <p>{`Go all the way right, to get `}<strong parentName="p">{`Journal 69`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Use the fight here to setup HP.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "moisonneusse-shield-guy"
      }}>{`Moisonneusse, Shield Guy`}</h4>
      <ul>
        <li parentName="ul">{`Verso: Perfect Recovery`}</li>
        <li parentName="ul">{`Lune: Wildfire (Fail QTE)`}</li>
        <li parentName="ul">{`Monoco: Flee`}</li>
      </ul>
    </Menu>
    <p>{`Fast Travel back to `}<strong parentName="p">{`Plazza`}</strong>{`.`}</p>
    <h4 {...{
      "id": "anger-vale"
    }}>{`Anger Vale`}</h4>
    <p>{`Go to Manor (right side after 1st hills).`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Verso Record`}</strong>{` and `}<strong parentName="p">{`Journal Unknown`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go back to flag and fast travel back to `}<strong parentName="p">{`Plazza`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Try to do this menu on the jumps.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-5"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Dualiso`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-10"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Glass Canon`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "formation-3"
      }}>{`Formation`}</h5>
      <p>{`-Monoco, +Sciel`}</p>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "visages-185114hp"
      }}>{`Visages 185114HP`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Need 440 speed for phase 1`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Determination Mask: Parry, Jump, Parry. Very easy audio cues`}</li>
          <li parentName="ul">{`Build shields with Peace Mask: 4 Parries on audio cue`}</li>
          <li parentName="ul">{`Anxiety Mask: 2 Parry, slight delay from audio cue.`}</li>
          <li parentName="ul">{`Doubt Mask: 5 Parry, go off visual cues. 1st one is slower than it looks. Audio cue is too early.`}</li>
        </ul>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`If Lune is 11 Might, watch for crit damage and add Lune Shots T2 if needed).`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-10"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Shoot twice, Berserk Slash`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <p>{`Parry & Counter for damage.`}</p>
      <h5 {...{
        "id": "turn-1-14"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Leadership`}</li>
        <li parentName="ul">{`Lune: Wildfire (Finish Phase)`}</li>
      </ul>
      <h4 {...{
        "id": "mask-keeper-185114hp-156"
      }}>{`Mask Keeper 185114HP (1:56)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`157690XP, $11760, Immaculate + 6 Resplendent Chroma Catalyst x6 + 0-3 Recoat`}<br parentName="p"></br>{`
`}{`Need some amount of speed over 468.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Attacks the Expedition: 4 Parries, visual cue off the circle build up of his attack.`}</li>
          <li parentName="ul">{`Swing Combo: 3 Parry, 2nd Parry tiny delay after 1st.`}</li>
          <li parentName="ul">{`Attacks like a Storm: 4 parries, visual/audio cue.`}</li>
          <li parentName="ul">{`Sets fire to his sword: 3 quick parries into a gradient`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-11"
      }}>{`Turn 1.1`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Intervention`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-9"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Leadership / `}<em parentName="li">{`If 2-3 AoE Parries`}</em>{` Powerful`}</li>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Sciel: Intervention`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "check-up-on-others"
    }}>{`Check Up on Others`}</h4>
    <p>{`Talk to campfire, and back out. Then talk to it again, and `}<strong parentName="p">{`Check up on others.`}</strong><br parentName="p"></br>{`
`}{`This should get you a skippable cutscene that gives you `}<strong parentName="p">{`Lettre A Maelle`}</strong>{`.`}<br parentName="p"></br>{`
`}{`If you get an unskippable cutscene instead, check up on others again. `}<strong parentName="p">{`Lettre A Maelle is missable!`}</strong>{`.`}</p>
    <p>{`Then go to Curator.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons-2"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Deminerim +4 (13)`}</li>
        <li parentName="ul">{`Sciel: Scieleson +3 (8)`}</li>
      </ul>
    </Menu>
    <p>{`Talk to Maelle, go up to Relationship LV4. Go to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-6"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +15 Luck (24)`}</li>
        <li parentName="ul">{`Verso: +17 Might (49), +1 Agility (29)`}</li>
        <li parentName="ul">{`Sciel: +15 Might (61)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-6"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: +Sealed Fate, +Card Weaver`}</li>
        <li parentName="ul">{`Sciel: Equip Card Weaver Right-Bottom, Equip Sealed Fate Left-Bottom, Equip Twilight Slash Right-Middle`}</li>
      </ul>
    </Menu>
    <p>{`Get Sciel to Relationship LV3. She has less text here, but want to stop before relationship stuff.`}<br parentName="p"></br>{`
`}{`Go to sleep.`}</p>
    <h3 {...{
      "id": "sirene"
    }}>{`Sirene`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`Journal 55`}</strong>{`.`}</p>
    <p>{`Start battle with a group of Ballets.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "ballets-027"
      }}>{`Ballets (0:27)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`21624XP (NB), $1410, Ballaro LV13`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-11"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Skip`}</li>
        <li parentName="ul">{`Lune: Wildfire (Fail QTE)`}</li>
        <li parentName="ul">{`Sciel: Skip`}</li>
      </ul>
      <p>{`They should kill both characters`}</p>
      <h5 {...{
        "id": "turn-1-15"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Monoco/Maelle: Flee`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Colour of Lumina`}</strong>{` near shadow Renoir.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-11"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+At Death's Door > Augmented First Strike`}</li>
            <li parentName="ul">{`+Confident Fighter > At Death's Door (Swap)`}</li>
            <li parentName="ul">{`+Immaculate > Breaker`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-7"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`-Energising Start I`}</li>
            <li parentName="ul">{`+Critical Moment`}</li>
            <li parentName="ul">{`+At Death's Door`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "glissando-350757hp-059"
      }}>{`Glissando 350757HP (0:59)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`51897XP, $2820, 1 Resplendent Chroma Catalyst`}<br parentName="p"></br>{`
`}{`515 speed seems to be the cutoff for him to not get 2 moves in T1.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Enchants its target: 1 hit. 2 explosions > Parry. Use rhythm.`}</li>
          <li parentName="ul">{`Smashes its head: 2 Parry, can visually/audio react`}</li>
          <li parentName="ul">{`Smashes its tail: 3 Parry, need to find cue. 1st visual on slowdown, 2nd audio, 3rd delayed audio.`}</li>
          <li parentName="ul">{`Summons ballets: 3 jumps, easy.`}</li>
          <li parentName="ul">{`Attacks with her fabric: one on each character, not sure on timing cue yet.`}</li>
        </ul>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`You can skip Verso Attack here, but will potentially need extra damage T1. Only do it if you're comfortable here.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-12"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Energy Tint Sciel`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Card Weaver > Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <p>{`If he does Enchant, consider adding a few shots for safety.`}</p>
      <h5 {...{
        "id": "turn-1-16"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Shoot till C Rank, Leadership`}</li>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul">{`Sciel: Gradient > Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Journal 67`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "sirene-303990hp-108"
      }}>{`Sirene 303990HP (1:08)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`129744XP, $7050, Tisseron + Energising Turn + Resplendent Chroma Catalyst x3`}<br parentName="p"></br>{`
`}{`She goes frantic at 80%? HP? After she does, her next move will be Grand Ballet.`}<br parentName="p"></br>{`
`}{`If you transition her there with a parry off her 1st move, she will skip her 2nd move.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Glissandos: 2 Parries`}</li>
          <li parentName="ul">{`Charm: 1 Parry, same timing as Glissando enchants. 2 Explosions > Parry`}</li>
          <li parentName="ul">{`Seduce: Gradient`}</li>
          <li parentName="ul">{`Grand Ballet: 5 Hits, watch ballets + audio cue. 1st one is earlier than you'd think, last one you have to be patient for.`}</li>
        </ul>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`If Verso hits all crits, fail QTE on Twilight Slash`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-13"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Berserk Slash`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Card Weaver > Twilight Slash`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If she goes frantic before her move, you did too much damage. Adjust with QTEs next time.`}</p>
      </blockquote>
      <p>{`Parry Glissando's, she should go frantic`}</p>
      <h5 {...{
        "id": "turn-1-17"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Leadership`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
        <li parentName="ul">{`Sciel: Gradient > Sealed Fate`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "camp-3"
    }}>{`Camp`}</h3>
    <p>{`Get Monoco to Relationship LVL4, start duel`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "monoco-43000hp-014"
      }}>{`Monoco ~43000HP? (0:14)`}</h4>
      <ul>
        <li parentName="ul">{`Defiant Strike > Attack > Berserk Slash`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "continent-5"
    }}>{`Continent`}</h3>
    <p>{`After 1st cutscene by Monolith, pick up `}<strong parentName="p">{`Journal 40`}</strong>{` right by the Merchant on the island.`}</p>
    <h3 {...{
      "id": "the-monolith"
    }}>{`The Monolith`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-6"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Delaram`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-12"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Combo Attack > Critical Moment`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "the-paintress"
      }}>{`The Paintress`}</h4>
      <ul>
        <li parentName="ul">{`Verso: Perfect Recovery`}</li>
        <li parentName="ul">{`Lune: Wildfire fail QTE`}</li>
        <li parentName="ul">{`Sciel: Skip x3`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapon-7"
      }}>{`Weapon`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Dualiso`}</li>
        <li parentName="ul">{`Sciel: Tisseron`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-13"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Energising Turn`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "flying-waters-1"
    }}>{`Flying Waters`}</h4>
    <p>{`Talk to `}<strong parentName="p">{`Merchant`}</strong>{` in Flying Waters.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-1"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`6 Polished Chroma Catalysts (10 total)`}</li>
        <li parentName="ul">{`5 Resplendent Chroma Catalyst`}</li>
        <li parentName="ul">{`3 Colour of Lumina`}</li>
        <li parentName="ul">{`1 Recoat `}<strong parentName="li">{`if not owned. If bought, pick up chroma in SWC section here and by Julie journal.`}</strong></li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "ancient-sanctuary-1"
    }}>{`Ancient Sanctuary`}</h4>
    <p>{`Run into the first fight with `}<strong parentName="p">{`Robust and Ranger Sakapatate`}</strong></p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "robust-sakapatate-ranger-sakapatate-038"
      }}>{`Robust Sakapatate, Ranger Sakapatate (0:38)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`28596XP, $1704, Sakaram LV15`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-14"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack Ranger > Shoot Robust 3 times, Berserk Slash Robust`}</li>
        <li parentName="ul">{`Lune: Wildfire`}</li>
        <li parentName="ul"><strong parentName="li">{`DO NOT DODGE THE ROBUST DEATH, WANT IT TO KILL YOU`}</strong></li>
        <li parentName="ul">{`Maelle: Spark, dodge Ranger Death`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "stone-wave-cliffs-1"
    }}>{`Stone Wave Cliffs`}</h4>
    <p>{`Pick up `}<strong parentName="p">{`Resplendant Chroma Catalyst`}</strong>{` before grapple to SWC section.`}</p>
    <p>{`Pick up `}<strong parentName="p">{`Weakness Gain`}</strong>{` at the end of the `}<strong parentName="p">{`Stone Wave Cliffs`}</strong>{` section. It's behind the statue on the right.`}</p>
    <h4 {...{
      "id": "forgotten-battlefield-1"
    }}>{`Forgotten Battlefield`}</h4>
    <p>{`Go to Manor, pick up `}<strong parentName="p">{`L'Amour d'une Mère`}</strong>{` and `}<strong parentName="p">{`Journal Aline`}</strong>{`.`}</p>
    <h4 {...{
      "id": "lumiere"
    }}>{`Lumiere`}</h4>
    <p>{`Go to north east section. Pick up `}<strong parentName="p">{`Colour of Lumina`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Journal 70`}</strong>{`. For the enemies, aggro all, lure them to where you grappled from, then go for the Journal on the left side.`}</p>
    <p>{`Go to any flag along the way.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-7"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +9 Agility (46)`}</li>
        <li parentName="ul">{`Sciel: +9 Luck (18)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-7"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +Storm Caller`}</li>
        <li parentName="ul">{`Lune: Equip Storm Caller Right-Top`}</li>
        <li parentName="ul">{`Sciel: +All Set`}</li>
        <li parentName="ul">{`Sciel: Equip All Set Right-Top`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "renoir-2-370890hp-111"
      }}>{`Renoir 2 370890HP (1:11)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`173736XP, $8520, Second Chance + 3 Resplendent Chroma Catalyst`}<br parentName="p"></br>{`
`}{`724 Speed is the cutoff here. 732 doesn't work.`}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Attempts to Vanish: 2 hit, Parry into Gradient. Parry right before he hits black orb. Gradient when back turned.`}</li>
          <li parentName="ul">{`Melee Combo: 6 hit, gradient last?`}</li>
          <li parentName="ul">{`Incredible amount of chroma: 2 Parries, Gradient. Parry as soon as you see the ball shrink.`}</li>
          <li parentName="ul">{`Waves of Chroma: 5 Parry, last is delayed`}</li>
          <li parentName="ul">{`Attacks from a distance: 4 attacks, 1st 3 parry on slow down. 4th is ground pound.`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-0-15"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > 1 Shot, Leadership`}</li>
        <li parentName="ul">{`Lune: Storm Caller`}</li>
        <li parentName="ul">{`Sciel: Focused Fortell`}</li>
      </ul>
      <p>{`Dodge here if possible.`}</p>
      <h5 {...{
        "id": "turn-1-18"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Powerful`}</li>
        <li parentName="ul">{`Sciel: Sealed Fate`}</li>
        <li parentName="ul">{`Lune: Ice Lance`}</li>
      </ul>
      <p>{`If no counter T1, I recommend countering here. It's not necessary, but damage is VERY tight without it.`}</p>
      <h5 {...{
        "id": "turn-2-10"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Shots, Berserk Slash / Defiant Strike / Attack. You need to control damage here to get him as close to half as possible.`}</li>
        <li parentName="ul">{`Sciel: Shoot until 2 AP, Gradient > Sealed Fate`}</li>
      </ul>
      <p>{`This should kill, if not get fucked.`}</p>
    </Menu>
    <p>{`Menu before Paintress`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-14"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +Weakness Gain > First Strike`}</li>
      </ul>
      <h5 {...{
        "id": "lumina-8"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +First Strike`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "the-paintress-482157hp-413"
      }}>{`The Paintress 482157HP (4:13)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`173736XP, $8519, Painted Power + 3 Resplendent Chroma Catalyst`}<br parentName="p"></br>{`
`}{`Need >= 744 Speed `}</p>
      </blockquote>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Void Meteors: 7 projectiles left to right. They kind of explode before launching, parry as soon as you see it.`}</li>
          <li parentName="ul">{`Gradient Attack: 1 Gradient`}</li>
          <li parentName="ul">{`Chroma Waves: 4 hits, 2nd one right after 1st. Audio cue works. Parry on start of cue.`}</li>
          <li parentName="ul">{`Scatters Chroma: 5 hits, parry once the black waves go into the circle. No more waves around circle > parry.`}</li>
          <li parentName="ul">{`Manipulates Rocks from the Monolith: 3 hit AoE, parry after the rock moves back?`}</li>
        </ul>
      </blockquote>
      <p>{`Parry only the AoE moves, and you can dodge 1 to avoid the counter unless noted otherwise.`}<br parentName="p"></br>{`
`}{`You want to slightly underdamage, so you can kill with the parry counter on her 4th move.`}</p>
      <h5 {...{
        "id": "turn-0-16"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Skip`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Intervention Lune`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
      </ul>
      <p>{`Dodge Meteors`}</p>
      <h5 {...{
        "id": "turn-1-19"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Shoot / Attack if needed for C-rank, Leadership `}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: All Set`}</li>
      </ul>
      <p>{`Parry Gradient, Parry Chroma Waves and counter.`}</p>
      <h5 {...{
        "id": "turn-2-11"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Berserk Slash`}</li>
        <li parentName="ul">{`Lune: Lightning Dance`}</li>
        <li parentName="ul">{`Sciel: Gradient > Sealed Fate (Don't fail QTE)`}</li>
      </ul>
      <p>{`Parry all 5 chroma scatters, transition with counter.`}</p>
      <h4 {...{
        "id": "phase-2"
      }}>{`Phase 2`}</h4>
      <blockquote>
        <ul parentName="blockquote">
          <li parentName="ul">{`Summons giant brush of light: 3 hit aoe, parry on swing. Has audio cue similar to Chroma Waves`}</li>
          <li parentName="ul">{`Flies into the air: 5 hit, 2nd dodge on twirl, 3rd is slow, 4th is right after 3rd.`}</li>
          <li parentName="ul">{`Tears reality apart: 5 projectiles, dodge / parry at their "arc". Randomly start from left or right.`}</li>
          <li parentName="ul">{`Paintress unleashes: 7 single target into AoE`}</li>
          <li parentName="ul">{`Attacks from afar: Jump into 3 parry. Patient for jump`}</li>
        </ul>
      </blockquote>
      <p>{`You might not need all this damage, but you do need to keep doing stuff to generate Gradient`}</p>
      <h5 {...{
        "id": "turn-1-20"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Attack > Berserk Slash`}</li>
        <li parentName="ul">{`Lune: Elemental Trick`}</li>
        <li parentName="ul">{`Sciel: Gradient > Sealed Fate`}</li>
      </ul>
      <p>{`She will get 2 turns here. Giant brush > parry first 2 and dodge 3rd.`}<br parentName="p"></br>{`
`}{`Dodge all the moves of flies into the air. No perfect dodges required, just survive.`}</p>
      <h5 {...{
        "id": "turn-2-12"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Lightning Dance (She outspeeds because Rush wore off for the others, might depend on speed)`}</li>
        <li parentName="ul">{`Verso: Attack > Powerful`}</li>
        <li parentName="ul">{`Sciel: Gradient > Sealed Fate`}</li>
      </ul>
      <h4 {...{
        "id": "phase-3-72323hp"
      }}>{`Phase 3 ~72323HP`}</h4>
      <h5 {...{
        "id": "turn-1-21"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Skip`}</li>
        <li parentName="ul">{`Verso: Shoot if needed for S-Rank achievement, Defiant Strike`}</li>
        <li parentName="ul">{`Sciel: Sealed Fate`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "the-manor"
    }}>{`The Manor`}</h3>
    <p>{`Flip the switches on the right side.`}</p>
    <h2 {...{
      "id": "act-iii"
    }}>{`Act III`}</h2>
    <h3 {...{
      "id": "camp-4"
    }}>{`Camp`}</h3>
    <p>{`Talk to everyone. Talk to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-8"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +30 Defense (30)`}</li>
        <li parentName="ul">{`Sciel: Recoat, +96 Agility (96)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-8"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +Phantom Strike, +Stendhal, +Last Chance`}</li>
        <li parentName="ul">{`Maelle: Equip Last Chance Left-Top, Phantom Strike Left-Middle, Stendhal Left-Bottom`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-4"
      }}>{`Formation`}</h5>
      <p>{`-Everyone but Maelle, +Sciel`}</p>
      <h5 {...{
        "id": "weapons-2"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Delaram`}</li>
      </ul>
      <h5 {...{
        "id": "pictos-15"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`-Confident Fighter`}</li>
            <li parentName="ul">{`+Glass Canon > Immaculate (Swap)`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`-Combo Attack`}</li>
            <li parentName="ul">{`-Exposing Attack`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle`}<ul parentName="li">
            <li parentName="ul">{`-Slot 3`}</li>
            <li parentName="ul">{`+Painted Power`}</li>
            <li parentName="ul">{`+Confident Fighter`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-9"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle`}<ul parentName="li">
            <li parentName="ul">{`+Dead Energy II`}</li>
            <li parentName="ul">{`+Critical Moment`}</li>
            <li parentName="ul">{`+At Death's Door`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel`}<ul parentName="li">
            <li parentName="ul">{`+Energising Start`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Talk to campfire, Option 2. Go to Lumiere.`}</p>
    <h3 {...{
      "id": "lumiere-1"
    }}>{`Lumiere`}</h3>
    <p>{`Fight Abberation on the right.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "abberation"
      }}>{`Abberation`}</h4>
      <ul>
        <li parentName="ul">{`Maelle Last Chance, Sciel Intervention, Maelle Stendhal`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Colour of Lumina`}</strong>{` on the right after the 1st grapple.`}<br parentName="p"></br>{`
`}{`If you missed a Lumina, pick up `}<strong parentName="p">{`Colour of Lumina`}</strong>{` by cart.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Journal 60`}</strong>{`.`}</p>
    <p>{`Talk to Merchant`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-2"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`5 Resplendent Chroma Catalyst`}</li>
        <li parentName="ul">{`3 Color of Lumina (10)`}</li>
      </ul>
    </Menu>
    <p>{`Go to flag by fountain.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons-3"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Medalum: +13 (18)`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-attributes-9"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +10 (39)`}</li>
      </ul>
    </Menu>
    <p>{`Creation: Flee. Menu after.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-5"
      }}>{`Formation`}</h5>
      <p>{`+Verso, -Maelle, +Maelle`}</p>
      <h5 {...{
        "id": "pictos-16"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Shortcut`}</li>
          </ul></li>
        <li parentName="ul">{`Lumina:`}<ul parentName="li">
            <li parentName="ul">{`+Glass Canon (37/37)`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "renoir-3-766292hp-156"
      }}>{`Renoir 3 766292HP (1:56)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`219600XP, $9800`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-17"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: All Set`}</li>
        <li parentName="ul">{`Verso: Leadership`}</li>
        <li parentName="ul">{`Maelle: Stendhal `}<strong parentName="li">{`(1.2 + 1.1 QTE)`}</strong>{`. Should do ~760000`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-22"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Intervention Maelle`}</li>
        <li parentName="ul">{`Maelle: Gradient Virtuose Strike`}</li>
      </ul>
      <h5 {...{
        "id": "turn-11-1"
      }}>{`Turn 1.1`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Stendhal `}<strong parentName="li">{`(1.2 + 1.2 QTE)`}</strong></li>
      </ul>
    </Menu>
    <p>{`Fight as Maelle.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "verso-157188hp-007"
      }}>{`Verso 157188HP (0:07)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`32940XP, $1470, Our Drafts Collide`}</p>
      </blockquote>
      <p>{`Rain of Fire (Fail QTE)`}</p>
    </Menu>
    <p>{`After 5 cutscenes, reload the save you were playing.`}<br parentName="p"></br>{`
`}{`Go to flag, Back to Continent`}</p>
    <h3 {...{
      "id": "continent-6"
    }}>{`Continent`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-6"
      }}>{`Formation`}</h5>
      <ul>
        <li parentName="ul">{`+Maelle, +Sciel`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Journal 64`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`The Meadows`}</strong>{`, pick up `}<strong parentName="p">{`Our Painted Family`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Twilight Quarry`}</strong>{`, pick up `}<strong parentName="p">{`Un 33 Decembre A Lumiere`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Ancient Gestral City`}</strong>{`, pick up `}<strong parentName="p">{`Light of the Past`}</strong>{`.`}</p>
    <p>{`Go to Abbest Cave.`}</p>
    <h3 {...{
      "id": "abbest-cave"
    }}>{`Abbest Cave`}</h3>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "abbest-161636hp-010"
      }}>{`Abbest 161636HP (0:10)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`70875XP, $4073, First Offensive, 2 Resplendent, 5 Lumina`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-18"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Tint Maelle`}</li>
        <li parentName="ul">{`Maelle: Stendhal`}</li>
      </ul>
    </Menu>
    <p>{`Go to flag, leave to Continent.`}</p>
    <h3 {...{
      "id": "continent-7"
    }}>{`Continent`}</h3>
    <p>{`Talk to Merchant in front of Yellow Harvest. Buy `}<strong parentName="p">{`Goblu ($1000)`}</strong>{`.`}</p>
    <p>{`Go to `}<strong parentName="p">{`Gestral Beach - Balance Beam`}</strong>{` and finish it (1/5).`}</p>
    <p>{`Fly to island west of here. Get `}<strong parentName="p">{`Lost Gestral (2/9)`}</strong>{` on west side.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`White Tree`}</strong>{`. Pick up `}<strong parentName="p">{`Journal 36`}</strong>{` and `}<strong parentName="p">{`Honeymoon in Lumiere`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Yellow Harvest (Back Entrance)`}</strong>{`.`}</p>
    <h3 {...{
      "id": "yellow-harvest"
    }}>{`Yellow Harvest`}</h3>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "glaise-75000hp-008"
      }}>{`Glaise ~75000HP (0:08)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`29028XP, $3550, Plenum, Energising Attack I, 3 Polished`}</p>
      </blockquote>
      <ul>
        <li parentName="ul">{`Verso 3 Shots, skip. Maelle Rain of Fire`}</li>
      </ul>
    </Menu>
    <p>{`Go right path. Make a right at flag to pick up `}<strong parentName="p">{`Journal 59`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go down original path. Once at the main area, head right.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Journal 44`}</strong>{`. Head behind ramp up ahead to pick up `}<strong parentName="p">{`Death Bomb`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go up ramp. Pick up `}<strong parentName="p">{`Journal 38`}</strong>{`. Grapple to Merchant.`}</p>
    <p>{`Fight the Merchant as Maelle.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "pinnaby-12000hp-003"
      }}>{`Pinnaby ~12000HP (0:03)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`4354XP, $533`}</p>
      </blockquote>
      <p>{`Attack or 3 shots.`}</p>
    </Menu>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-3"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`Teamwork ($9120)`}</li>
        <li parentName="ul">{`3 Colour of Lumina (8)`}</li>
        <li parentName="ul">{`Auto-death ($5320)`}</li>
      </ul>
    </Menu>
    <p>{`Jump back in the direction you came, jump on ledge. Take right path, use flag, back to continent.`}</p>
    <h3 {...{
      "id": "continent-8"
    }}>{`Continent`}</h3>
    <p>{`Go to `}<strong parentName="p">{`Lost Woods`}</strong>{`. Pick up `}<strong parentName="p">{`Aline's Glasshouse`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Crushing Cavern`}</strong>{`.`}</p>
    <h3 {...{
      "id": "crushing-cavern"
    }}>{`Crushing Cavern`}</h3>
    <p>{`Try to do this menu while falling down.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-17"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Teamwork`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle`}<ul parentName="li">
            <li parentName="ul">{`+First Offensive > Painted Power`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-10"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Painted Power`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "giant-sapling-135000hp-007"
      }}>{`Giant Sapling ~135000HP (0:07)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`23760XP, $1912, Solidifying, Polished`}</p>
      </blockquote>
      <p>{`Rain of Fire`}</p>
    </Menu>
    <p>{`At fork go left, pick up `}<strong parentName="p">{`Colour of Lumina`}</strong>{` and `}<strong parentName="p">{`Journal 45`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go back to original fork, take right path to exit.`}</p>
    <h3 {...{
      "id": "continent-9"
    }}>{`Continent`}</h3>
    <p>{`Go fight `}<strong parentName="p">{`Chromatic Demineur`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "chromatic-demineur-hp-011"
      }}>{`Chromatic Demineur ?HP (0:11)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`665280XP, $11543, 2 Grandiose + 5 Lumina`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-19"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Leadership`}</li>
        <li parentName="ul">{`Maelle: Shoot 9 times`}</li>
      </ul>
    </Menu>
    <p>{`Go to Floating Cemetary.`}</p>
    <h3 {...{
      "id": "floating-cemetary"
    }}>{`Floating Cemetary`}</h3>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "chalier-250000hp-010"
      }}>{`Chalier ~250000HP (0:10)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`64800XP, $1752, Longer Shell`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-20"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Energy Tint Maelle`}</li>
        <li parentName="ul">{`Maelle: Stendhal`}</li>
      </ul>
    </Menu>
    <p>{`Finish quest (kill) for `}<strong parentName="p">{`Auto Powerful`}</strong>{`. Talk to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-expedition-resources"
      }}>{`Upgrade Expedition Resources`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +14 (62)`}</li>
      </ul>
      <p>{`Back to Continent.`}</p>
    </Menu>
    <h3 {...{
      "id": "continent-10"
    }}>{`Continent`}</h3>
    <p>{`Go to `}<strong parentName="p">{`Falling Leaves`}</strong>{`.`}</p>
    <h3 {...{
      "id": "falling-leaves"
    }}>{`Falling Leaves`}</h3>
    <p>{`Tag flag at the start.`}<br parentName="p"></br>{`
`}{`Talk to boy. Go to grapple, pick up `}<strong parentName="p">{`$4010`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Menu on the jump.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-18"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Auto Powerful > Shortcut`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-11"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle`}<ul parentName="li">
            <li parentName="ul">{`+Augmented First Strike`}</li>
            <li parentName="ul">{`+Shortcut`}</li>
            <li parentName="ul">{`+Immaculate`}</li>
          </ul></li>
      </ul>
    </Menu>
    <p>{`Talk to `}<strong parentName="p">{`Lady of Sap`}</strong>{`. Go to manor. Pick up `}<strong parentName="p">{`Alicia`}</strong>{`.`}</p>
    <p>{`Continue down path. After handholds go left and pick up `}<strong parentName="p">{`Journal 35`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go talk to boy again and continue through gate. Pick up `}<strong parentName="p">{`Journal 49`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "scavenger-hp-010"
      }}>{`Scavenger ?HP (0:10)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`167184XP, $8020, Scaverim LV14, 3 Resplendent`}</p>
      </blockquote>
      <p>{`Energy Tint Maelle > Stendhall`}</p>
    </Menu>
    <p>{`Go to flag. Fast Travel to Resinveil Grove.`}<br parentName="p"></br>{`
`}{`Talk to boy to get `}<strong parentName="p">{`Until Next Life`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go back to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-10"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +33 Defense (63)`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-weapons-4"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Medalum +3 (21)`}</li>
      </ul>
      <p>{`Back to Continent.`}</p>
    </Menu>
    <h3 {...{
      "id": "continent-11"
    }}>{`Continent`}</h3>
    <p>{`Go to Camp`}</p>
    <h3 {...{
      "id": "camp-5"
    }}>{`Camp`}</h3>
    <p>{`Get `}<strong parentName="p">{`Maelle Relationship to 5.5 for quest`}</strong>{`.`}</p>
    <p>{`Go To Sleep`}</p>
    <h3 {...{
      "id": "continent-12"
    }}>{`Continent`}</h3>
    <p>{`Go to Sprong.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "sprong-3964471hp-021"
      }}>{`Sprong 3964471HP (0:21)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1056000XP, $11543, 3 Grandiose`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-21"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Defiant Strike`}</li>
        <li parentName="ul">{`Maelle: Last Chance > Stendhal`}</li>
      </ul>
    </Menu>
    <p>{`Go to `}<strong parentName="p">{`Blade's Graveyard`}</strong>{`, pick up `}<strong parentName="p">{`Reverance`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Journal Verso`}</strong>{` and `}<strong parentName="p">{`Journal Julie`}</strong>{`.`}</p>
    <p>{`Go to `}<strong parentName="p">{`Painting Workshop`}</strong>{`. Menu during jump.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapons-3"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Lune: (1U) Angerim`}</li>
        <li parentName="ul">{`Verso: Sakaram`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`There's 2 jumps, can seperate these`}</p>
      </blockquote>
      <h5 {...{
        "id": "pictos-19"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +Cheater > Inverted Affinity`}</li>
      </ul>
    </Menu>
    <p>{`Talk to boy for `}<strong parentName="p">{`Colour of the Beast`}</strong>{` and exit.`}</p>
    <h3 {...{
      "id": "continent-13"
    }}>{`Continent`}</h3>
    <p>{`Go to `}<strong parentName="p">{`Gestral Beach - Only Up`}</strong></p>
    <h3 {...{
      "id": "gestral-beach---only-up"
    }}>{`Gestral Beach - Only Up`}</h3>
    <p>{`Complete it. Menu on the jump down.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "lumina-12"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+(R2) Augmented First Strike`}</li>
            <li parentName="ul">{`+First Offensive`}</li>
            <li parentName="ul">{`+Painted Power`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+(R3) Teamwork`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "continent-14"
    }}>{`Continent`}</h3>
    <p>{`Go towards Bourgeon before Glaisum fight. Pick up `}<strong parentName="p">{`Journal 47`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Fight the Bourgeon.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "bourgeon-danseuse-something-else-008"
      }}>{`Bourgeon, Danseuse, Something Else (0:08)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`33566XP, $2514, Ramasson LV9, Abysseram LV9, Burning Death, Augmented Counter, Bourgeon Skin, Polished`}</p>
      </blockquote>
      <p>{`Energy Tint > Phantom Strike`}</p>
    </Menu>
    <blockquote>
      <p parentName="blockquote">{`The menus are split up here so you can do parts of them during jumps. You can choose to combine them into 1 menu.`}</p>
    </blockquote>
    <p>{`Go to `}<strong parentName="p">{`Esoteric Ruins`}</strong>{`.`}</p>
    <h3 {...{
      "id": "esoteric-ruins"
    }}>{`Esoteric Ruins`}</h3>
    <p>{`Talk to the Portier soul once at the start.`}</p>
    <p>{`For the puzzle, think of it as a grid in numpad formation (top-right is 9, bottom-left is 1)`}</p>
    <ol>
      <li parentName="ol">{`Enter 2, shoot 2.`}</li>
      <li parentName="ol">{`Enter 1, shoot 2 then shoot 1`}</li>
      <li parentName="ol">{`Enter 6, shoot 5.`}</li>
    </ol>
    <p>{`Do puzzle, pick up `}<strong parentName="p">{`Wood Boards`}</strong>{` on exit path.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "weapons-4"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: (1D) Ramasson`}</li>
      </ul>
    </Menu>
    <p>{`Go back, talk to White Portier complete quest.`}<br parentName="p"></br>{`
`}{`Go to flag, back to Continent.`}</p>
    <h3 {...{
      "id": "continent-15"
    }}>{`Continent`}</h3>
    <p>{`Go to island south of Visages, pick up `}<strong parentName="p">{`Lost Gestral (3/9)`}</strong>{` near mimes.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`The Crows`}</strong>{`, pick up `}<strong parentName="p">{`Journal 34`}</strong>{` and exit via flag.`}</p>
    <p>{`Go to `}<strong parentName="p">{`The Reacher`}</strong>{`.`}</p>
    <h3 {...{
      "id": "the-reacher"
    }}>{`The Reacher`}</h3>
    <blockquote>
      <p parentName="blockquote">{`You can setup Verso pictos & some of his lumina on the jumps down`}</p>
    </blockquote>
    <p>{`Go to manor. Pick up `}<strong parentName="p">{`Journal Unknown`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Journal 61`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "alicia-hp545190-006"
      }}>{`Alicia HP<545190 (0:06)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`475200XP, $12510, Lithum LV21, Resplendent x3`}</p>
      </blockquote>
      <p>{`Rain of Fire`}</p>
    </Menu>
    <p>{`Exit via Esquie.`}</p>
    <h3 {...{
      "id": "camp-6"
    }}>{`Camp`}</h3>
    <p>{`Finish Maelle Relationship 7 `}<strong parentName="p">{`MAKE SURE TO PICK OPTION 1 TO TELL TRUTH`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Talk to Lune, get her to Relationship 5.5.`}<br parentName="p"></br>{`
`}{`Go to sleep.`}</p>
    <h3 {...{
      "id": "continent-16"
    }}>{`Continent`}</h3>
    <p>{`Go to land directly north of you, get `}<strong parentName="p">{`Lost Gestral (4/9)`}</strong>{` in southern tip.`}<br parentName="p"></br>{`
`}{`Go to island north of Visages, talk to Merchant Rubiju. Buy `}<strong parentName="p">{`Linen and Cotton ($1000)`}</strong>{`.`}</p>
    <p>{`Go to `}<strong parentName="p">{`The Canvas`}</strong>{`, get `}<strong parentName="p">{`Portrait of the Dessendre Family`}</strong>{`.`}</p>
    <p>{`Go to `}<strong parentName="p">{`Painting Workshop`}</strong>{`. Talk to boy for `}<strong parentName="p">{`Colour of the Beast`}</strong>{` and exit.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-7"
      }}>{`Formation`}</h5>
      <p>{`-+Sciel, -+Lune`}</p>
    </Menu>
    <p>{`Go to `}<strong parentName="p">{`Gestral Beach - Speedrun`}</strong>{`. Finish it (3/5)`}</p>
    <p>{`Go to `}<strong parentName="p">{`Sinister Cave`}</strong>{`. Get `}<strong parentName="p">{`Nocturne pour Lumière`}</strong>{`.`}</p>
    <p>{`Go south to Endless Night Sanctuary area. Pick up `}<strong parentName="p">{`Lost Gestral (5/9)`}</strong>{`.`}</p>
    <p>{`Go west to `}<strong parentName="p">{`Gestral Beach - Wall Climb`}</strong>{`.`}</p>
    <h3 {...{
      "id": "gestral-beach---wall-climb"
    }}>{`Gestral Beach - Wall Climb`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`Journal 37`}</strong>{` directly right of entrance.`}<br parentName="p"></br>{`
`}{`For minigame, right side seems to get less. Once you get far enough, go to middle and react to where they fall. Watch top of screen.`}<br parentName="p"></br>{`
`}{`Complete minigame (4/5)`}</p>
    <h3 {...{
      "id": "continent-17"
    }}>{`Continent`}</h3>
    <p>{`Go to Island directly west of you. Buy `}<strong parentName="p">{`Robe de Jour`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Sirene's Dress`}</strong>{`.`}</p>
    <h3 {...{
      "id": "sirenes-dress"
    }}>{`Sirene's Dress`}</h3>
    <p>{`Option 2 to open door.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "chromatic-glissando-1174172hp-036"
      }}>{`Chromatic Glissando 1174172HP (0:36)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1075680XP, $13724, Choralim LV20, Ballaro LV20, 2 Grandiose, 5 Lumina`}</p>
      </blockquote>
      <h4 {...{
        "id": "turn-0-22"
      }}>{`Turn 0`}</h4>
      <ul>
        <li parentName="ul">{`Maelle: Last Chance > Stendhal`}</li>
        <li parentName="ul">{`Sciel: Intervention Maelle`}</li>
        <li parentName="ul">{`Maelle: Shoot Ballets 3 times each.`}</li>
      </ul>
    </Menu>
    <p>{`Pick up `}<strong parentName="p">{`Journal 46`}</strong>{`. Go back to flag, back to continent.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-8"
      }}>{`Formation`}</h5>
      <p>{`-+Sciel, -+Maelle`}</p>
      <h5 {...{
        "id": "pictos-20"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Auto-Death`}</li>
            <li parentName="ul">{`+Death Bomb`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-13"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+First Offensive`}</li>
            <li parentName="ul"><strong parentName="li">{`-Inverted Affinity`}</strong></li>
            <li parentName="ul">{`+Glass Canon`}</li>
            <li parentName="ul">{`+Painted Power`}</li>
            <li parentName="ul">{`+(R2) Augmented First Strike`}</li>
            <li parentName="ul">{`+Critical Moment`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "camp-7"
    }}>{`Camp`}</h3>
    <p>{`Finish Lune Relationship 7.`}<br parentName="p"></br>{`
`}{`Get Esquie to Relationship 5.5`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "francois-001"
      }}>{`Francois (0:01)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`14175XP, $815`}</p>
      </blockquote>
      <p>{`Death Bomb one shots.`}</p>
    </Menu>
    <p>{`Finish Relationships, get Monoco to 5.5.`}<br parentName="p"></br>{`
`}{`Go to Sleep.`}</p>
    <h3 {...{
      "id": "continent-18"
    }}>{`Continent`}</h3>
    <p>{`Go to `}<strong parentName="p">{`The Small Bourgeon`}</strong>{`.`}</p>
    <h3 {...{
      "id": "the-small-bourgeon"
    }}>{`The Small Bourgeon`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`Journal 53`}</strong>{`. Talk to White Bourgeon twice.`}<br parentName="p"></br>{`
`}{`Leave and re-enter area. Talk to White Bourgeon again and exit.`}</p>
    <h3 {...{
      "id": "continent-19"
    }}>{`Continent`}</h3>
    <p>{`Go to Red Woods.`}</p>
    <h3 {...{
      "id": "red-woods"
    }}>{`Red Woods`}</h3>
    <p>{`Give money to fountain 4 times to complete quest. Exit.`}</p>
    <h3 {...{
      "id": "continent-20"
    }}>{`Continent`}</h3>
    <p>{`Go to The Fountain south-west of here.`}</p>
    <h3 {...{
      "id": "the-fountain"
    }}>{`The Fountain`}</h3>
    <p>{`Talk Blanche. Should get 100 Lumina.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Journal 84`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to flag, back to Continent.`}</p>
    <h3 {...{
      "id": "continent-21"
    }}>{`Continent`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`Journal 62`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Stone Wave Cliffs (Back Entrance)`}</strong>{`.`}</p>
    <h3 {...{
      "id": "stone-wave-cliffs-2"
    }}>{`Stone Wave Cliffs`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`Gustave`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Continue to flag, fast travel to `}<strong parentName="p">{`Tide Caverns`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Talk to White Hexga twice. Go back to flag, back to Continent.`}</p>
    <h3 {...{
      "id": "continent-22"
    }}>{`Continent`}</h3>
    <p>{`Go towards `}<strong parentName="p">{`Stone Wave Cliffs`}</strong>{` Bourgeon, pick up `}<strong parentName="p">{`Lost Gestral (6/9)`}</strong>{`.`}</p>
    <p>{`Go to `}<strong parentName="p">{`Stone Wave Cliffs Cave`}</strong>{`.`}</p>
    <h3 {...{
      "id": "stone-wave-cliffs-cave"
    }}>{`Stone Wave Cliffs Cave`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`Journal 54`}</strong>{` and exit (no need to fight).`}</p>
    <h3 {...{
      "id": "continent-23"
    }}>{`Continent`}</h3>
    <p>{`Chase Chromatic Petank. Enter Manor.`}</p>
    <h3 {...{
      "id": "the-manor-1"
    }}>{`The Manor`}</h3>
    <p>{`Open Closet, pick up `}<strong parentName="p">{`Forlorn`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`The below is ~1s faster to do in Frozen Hearts Manor, but leaving it here so there's a chance to backup if you forget.`}</p>
    </blockquote>
    <p>{`Place `}<strong parentName="p">{`Dessendre Canvas`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Flip the 2 switches on the left side.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Journal Unknown`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick up `}<strong parentName="p">{`Nocturne pour un masque de tristesse`}</strong>{` in secret room.`}</p>
    <h3 {...{
      "id": "continent-24"
    }}>{`Continent`}</h3>
    <p>{`Finish chasing Chromatic Petank. For mob section, go above rocks on right wall and descend.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "chromatic-petank-033"
      }}>{`Chromatic Petank (0:33)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1471770XP, $159450, Anti-Stun, 2 Grandiose, 5 Lumina`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-23"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Lune: Electrify x2`}</li>
        <li parentName="ul">{`Sciel: Invervention Lune`}</li>
        <li parentName="ul">{`Lune: Electrify x2`}</li>
        <li parentName="ul">{`Maelle: Last Chance > Stendhal`}</li>
      </ul>
    </Menu>
    <p>{`Go to `}<strong parentName="p">{`Gestral Beach - Volleyball`}</strong>{`.`}</p>
    <h3 {...{
      "id": "gestral-beach---volleyball"
    }}>{`Gestral Beach - Volleyball`}</h3>
    <p>{`Do medium option, top isn't good enough for achievement. (5/5)`}</p>
    <h3 {...{
      "id": "continent-25"
    }}>{`Continent`}</h3>
    <p>{`Go to `}<strong parentName="p">{`Flying Casino`}</strong>{`.`}</p>
    <h3 {...{
      "id": "flying-casino"
    }}>{`Flying Casino`}</h3>
    <p>{`Pick up `}<strong parentName="p">{`Rêveries dans Paris`}</strong>{`. Go to Flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-11"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Lune: +66 Luck (90)`}</li>
        <li parentName="ul">{`Maelle: +36 Defense (99), +6 Agility (7)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-9"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: (Learn from All Set) Fortune Fury, Our Sacrifice`}</li>
        <li parentName="ul">{`Sciel: Fortune Fury Left-Bottom`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-weapons-5"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Medalum +4 (25)`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-expedition-resources-1"
      }}>{`Upgrade Expedition Resources`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +79? (155)`}</li>
      </ul>
      <p>{`Back to Continent`}</p>
    </Menu>
    <h3 {...{
      "id": "continent-26"
    }}>{`Continent`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-21"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Lune:`}<ul parentName="li">
            <li parentName="ul">{`+Death Bomb > Cheater`}</li>
            <li parentName="ul">{`+Auto-Death > Weakness Gain`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-14"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+(L2,R3) Exposing Attack (42/55)`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Energising Turn`}</li>
            <li parentName="ul">{`+Energising Start III`}</li>
            <li parentName="ul">{`+Energising Start I (107/139)`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "formation-9"
      }}>{`Formation`}</h5>
      <p>{`-Lune, +Monoco`}</p>
    </Menu>
    <p>{`Go to `}<strong parentName="p">{`Painting Workshop`}</strong>{`.`}</p>
    <h3 {...{
      "id": "painting-workshop"
    }}>{`Painting Workshop`}</h3>
    <p>{`Get last `}<strong parentName="p">{`Colour of the Beast`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Progress, use all 3 Colour of the Beast. Go fight `}<strong parentName="p">{`Lampmaster`}</strong></p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "lampmaster-hp10759702-011"
      }}>{`Lampmaster HP<10759702 (0:11)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`2925000XP, $22240, At Death's Door LV30, Energising Attack LV30, 3 Grandiose, 0-2 Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-24"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Fortune Fury Maelle`}</li>
        <li parentName="ul">{`Maelle: Stendhal`}</li>
      </ul>
    </Menu>
    <p>{`Exit via portal (Can't from flag)`}</p>
    <h3 {...{
      "id": "continent-27"
    }}>{`Continent`}</h3>
    <p>{`Go to `}<strong parentName="p">{`Boat Graveyard`}</strong>{`. Pick up `}<strong parentName="p">{`Alicia's Birthday Party`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Fight `}<strong parentName="p">{`Serpenphare`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "serpenphare--hp10987742-011"
      }}>{`Serpenphare  HP<10987742 (0:11)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`2340000XP, $22240, Energy Master, 1 Perfect + 3 Grandiose`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-25"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Fortune Fury Maelle`}</li>
        <li parentName="ul">{`Maelle: Stendhal`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "continent-28"
    }}>{`Continent`}</h3>
    <p>{`Go to White Sands. Pick up `}<strong parentName="p">{`Aline`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons-6"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Medalum +2 (27)`}</li>
      </ul>
      <p>{`Back to Continent`}</p>
    </Menu>
    <h3 {...{
      "id": "continent-29"
    }}>{`Continent`}</h3>
    <p>{`Go to island north of here. Pick up `}<strong parentName="p">{`Journal 43`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to island west of here. Pick up `}<strong parentName="p">{`Lost Gestral (7/9)`}</strong>{` near Stalact group.`}<br parentName="p"></br>{`
`}{`Fight Gross Tete.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "gross-tete-hp3908753-008"
      }}>{`Gross Tete HP<3908753 (0:08)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`81000XP, $3612, Warming Up, 1 Resplendent`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-26"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Attack`}</li>
        <li parentName="ul">{`Maelle: Stendhal`}</li>
      </ul>
    </Menu>
    <p>{`Go to `}<strong parentName="p">{`Stone Quarry`}</strong></p>
    <h3 {...{
      "id": "stone-quarry"
    }}>{`Stone Quarry`}</h3>
    <p>{`Make `}<strong parentName="p">{`Lune`}</strong>{` leader. Pick up `}<strong parentName="p">{`Journal 48`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Talk to White Troubadour, should get auto-cleared via Death Bomb. (9450XP, $543).`}<br parentName="p"></br>{`
`}{`Talk to it again to complete quest.`}</p>
    <h3 {...{
      "id": "continent-30"
    }}>{`Continent`}</h3>
    <p>{`Head north, pick up `}<strong parentName="p">{`Lost Gestral (8/9)`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Talk to Merchant, buy `}<strong parentName="p">{`Lost Voice ($1000)`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`The Carousel`}</strong>{`.`}</p>
    <h3 {...{
      "id": "the-carousel"
    }}>{`The Carousel`}</h3>
    <p>{`After flag, head left and pick up `}<strong parentName="p">{`Le Grand Café de Lumière`}</strong>{`.`}</p>
    <h3 {...{
      "id": "continent-31"
    }}>{`Continent`}</h3>
    <p>{`Go to Frozen Hearts`}</p>
    <h3 {...{
      "id": "frozen-hearts"
    }}>{`Frozen Hearts`}</h3>
    <p>{`Go north west, head up to Danseuse.`}<br parentName="p"></br>{`
`}{`Talk to White Danseuse. Lune should one-shot with Death Bomb (71077HP, 69498XP, $1395)`}<br parentName="p"></br>{`
`}{`This should complete `}<strong parentName="p">{`Aiding the Enemy`}</strong>{`.`}</p>
    <p>{`Backtrack, take right path, go to Manor. Pick up `}<strong parentName="p">{`Clea Don't Pull Your Sister's Hair!`}</strong>{`.`}<br parentName="p"></br>{`
`}{`After exiting Manor, take a hard left and go down tracks. Pick up `}<strong parentName="p">{`Burn Affinity`}</strong>{`.`}</p>
    <p>{`Go left from the train. Pick up `}<strong parentName="p">{`Journal 51`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Run back towards entrance, talk to flag.`}</p>
    <h3 {...{
      "id": "continent-32"
    }}>{`Continent`}</h3>
    <p>{`Go to `}<strong parentName="p">{`Flying Manor`}</strong>{`.`}</p>
    <h3 {...{
      "id": "flying-manor"
    }}>{`Flying Manor`}</h3>
    <p>{`Take NW path first.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "chromatic-goblu-5000000hp-009"
      }}>{`Chromatic Goblu ~5000000HP (0:09)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1603800XP, $19900, Gobluson LV28, 3 Grandiose`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-27"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Shoot twice, Attack`}</li>
        <li parentName="ul">{`Maelle: Stendhal`}</li>
      </ul>
    </Menu>
    <p>{`Talk to boy to return. Take SW path.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-22"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Burning Death > Teamwork`}</li>
            <li parentName="ul">{`+(Triangle) At Death's Door > Glass Canon`}</li>
            <li parentName="ul">{`+(Triangle) Cheater > Energising Turn`}</li>
          </ul></li>
        <li parentName="ul">{`Monoco:`}<ul parentName="li">
            <li parentName="ul">{`+Energy Master`}</li>
            <li parentName="ul">{`+Burn Affinity`}</li>
            <li parentName="ul">{`+Warming Up`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "dualliste-15000000hp-013"
      }}>{`Dualliste ~15000000HP (0:13)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1603800XP, $19900, Dualiso LV28, 1 Perfect, 3 Grandiose, 0-1 Recoat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-28"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Fortune Fury > Attack`}</li>
        <li parentName="ul">{`Maelle: Stendhal`}</li>
      </ul>
    </Menu>
    <p>{`Talk to boy to return, take SE path.`}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "gargant-2-danseuse-5500000hp-018"
      }}>{`Gargant, 2 Danseuse ~5500000HP (0:18)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`2662308XP, $23988, Snowim LV29, Anti-Burn LV29, Burning Death LV29, 3 Grandiose`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-29"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Fortune Fury > Attack Gargant`}</li>
        <li parentName="ul">{`Maelle: Shoot Danseuse Head x2, Shoot Danseuse Head x3, Stendhal`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-10"
      }}>{`Formation`}</h5>
      <p>{`-+Sciel, -+Monoco`}</p>
      <h5 {...{
        "id": "lumina-15"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: `}<ul parentName="li">
            <li parentName="ul">{`+(L2) Cheater (147/168)`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "lampmaster-hp6360000-007"
      }}>{`Lampmaster HP<6360000 (0:07)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`2405700XP, $19900, Joyaro, 1 Perfect, 3 Grandiose`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-30"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Stendhal`}</li>
      </ul>
    </Menu>
    <p>{`Talk to boy to return, take NE Path.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Chroma Elixer!`}</strong></p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "eveques-hp2800000-042"
      }}>{`Eveques HP<2800000 (0:42)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1659933XP, $44979, Kralim LV28, 1 Perfect, 6 Grandiose, 15 Lumina`}</p>
      </blockquote>
      <blockquote>
        <p parentName="blockquote">{`The Invincibility changes at the start of each turn, don't get tricked by it while it's loading! It also doesn't always switch.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-31"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Stendhal vulnerable Eveque > Last Chance > Stendhal vulnerable Eveque`}</li>
        <li parentName="ul">{`Sciel: Intervention Maelle`}</li>
        <li parentName="ul">{`Maelle: Last Chance > Stendhal last Eveque`}</li>
      </ul>
    </Menu>
    <p>{`Talk to boy to return. Go to Clea.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-11"
      }}>{`Formation`}</h5>
      <p>{`-+Maelle, -+Monoco`}</p>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "clea-1500000hp-013"
      }}>{`Clea ~1500000HP (0:13)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`2340000XP, $22240, Clea's Life, 1 Perfect, 3 Grandiose`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-32"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Attack > Fortune Fury`}</li>
        <li parentName="ul">{`Maelle: Stendhal`}</li>
      </ul>
    </Menu>
    <p>{`Go to flag.`}</p>
    <Menu mdxType="Menu">
      <p><strong parentName="p">{`DO NOT REST`}</strong></p>
      <h5 {...{
        "id": "upgrade-attributes-12"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: +99 Luck (99)`}</li>
        <li parentName="ul">{`Maelle: +54 Agility (61)`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-spectral-sweep"
      }}>{`Learn Skills !!!SPECTRAL SWEEP!!!`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: +Marking Card, +Delaying Slash`}</li>
        <li parentName="ul">{`Sciel: Delaying Slash Right-Middle, Marking Card Right-Top, `}<strong parentName="li">{`SPECTRAL SWEEP Right-Bottom`}</strong></li>
        <li parentName="ul">{`Maelle: +Guard Down`}</li>
        <li parentName="ul">{`Maelle: Guard Down Right-Middle, +Mezzo-Forte Right-Top`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-weapons-7"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Medalum +6 (33)`}</li>
      </ul>
      <p>{`Return to Continent`}</p>
    </Menu>
    <h3 {...{
      "id": "continent-33"
    }}>{`Continent`}</h3>
    <p>{`Go to Old Lumiere (front entrance)`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-12"
      }}>{`Formation`}</h5>
      <p>{`-+Maelle, -+Sciel`}</p>
      <h5 {...{
        "id": "pictos-23"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Energising Attack > First Offensive`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-16"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: `}<ul parentName="li">
            <li parentName="ul">{`-Energising Turn`}</li>
            <li parentName="ul">{`-Energising Start III`}</li>
            <li parentName="ul">{`+Energy Master`}</li>
            <li parentName="ul">{`+First Offensive`}</li>
            <li parentName="ul">{`+(R3) Warming Up (172/172)`}</li>
          </ul></li>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`Reset`}</li>
            <li parentName="ul">{`+(L2) First Strike`}</li>
            <li parentName="ul">{`+Energising Turn`}</li>
            <li parentName="ul">{`+Energy Master`}</li>
          </ul></li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "old-lumiere-2"
    }}>{`Old Lumiere`}</h3>
    <p>{`Go to Chromatic Danseuse`}</p>
    <Menu mdxType="Menu">
      <p>{`We are killing 18 loops, or 36 Dancers total. A loop is 2 Dancers killed, so a typical Maelle turn is 2 loops.`}</p>
      <h4 {...{
        "id": "chromatic-danseuse-150000hp-509"
      }}>{`Chromatic Danseuse ~150000HP (5:09)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`197842536XP, $138491, Danseso, Revive Paradox, 74 Polished, 185 Lumina`}</p>
      </blockquote>
      <p><strong parentName="p">{`Fail all Sciel QTEs except Spectral Sweep`}</strong>{`.`}</p>
      <h5 {...{
        "id": "turn-0-33"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Monoco: Skip`}</li>
        <li parentName="ul">{`Maelle: Shoot summons 2-3 times, Mezzo Forte > Shoot Summons 3-3, Mezzo Forte`}</li>
        <li parentName="ul">{`Sciel: Intervention Maelle`}</li>
        <li parentName="ul">{`Maelle: Shoot summons 3-3 times, Mezzo Forte > Shoot Summons 5-5 times, Mezzo Forte`}</li>
      </ul>
      <h5 {...{
        "id": "turn-1-23"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Focused Foretell > Delaying Slash Chromatic Danseuse`}</li>
        <li parentName="ul">{`Maelle: (Shoot Summon 4-4 times, Mezzo Forte) x2`}</li>
        <li parentName="ul">{`Monoco: Sakapatate Estoc`}</li>
      </ul>
      <p>{`You loop this until Monoco does his 4th Sakapatate Estoc and you get Wheel Control Achievement`}</p>
      <h5 {...{
        "id": "after-wheel-control"
      }}>{`After Wheel Control`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Spectral Sweep `}<strong parentName="li">{`(1.1 + 1.1 QTE)`}</strong>{` > Delaying Slash Chromatic Danseuse`}</li>
        <li parentName="ul">{`Maelle: (Shoot Summon 4-4 times, Mezzo Forte) x2`}</li>
        <li parentName="ul">{`Sciel: Skip x2`}</li>
        <li parentName="ul">{`Maelle: Shoot Summon 4 times, Gommage other summon > Phantom Strike`}</li>
      </ul>
    </Menu>
    <p>{`Go to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-attributes-13"
      }}>{`Upgrade Attributes`}</h5>
      <ul>
        <li parentName="ul">{`Verso: 99 Vitality, 99 Agility, 69 Might`}</li>
        <li parentName="ul">{`Maelle: +47 Might (90), +38 Agility (99)`}</li>
        <li parentName="ul">{`Monoco: +21 Agility (99), +90 Might (90), +99 Defense (99)`}</li>
      </ul>
      <h5 {...{
        "id": "upgrade-expedition-resources-2"
      }}>{`Upgrade Expedition Resources`}</h5>
      <ul>
        <li parentName="ul">{`Monoco: +65 (161)`}</li>
      </ul>
      <p>{`Back to Continent.`}</p>
    </Menu>
    <h3 {...{
      "id": "continent-34"
    }}>{`Continent`}</h3>
    <p>{`Go to Renoir's Drafts.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-13"
      }}>{`Formation`}</h5>
      <p>{`-+Maelle, -+Monoco`}</p>
    </Menu>
    <h3 {...{
      "id": "renoirs-drafts"
    }}>{`Renoir's Drafts`}</h3>
    <p>{`After ramp, go left and pick up `}<strong parentName="p">{`Endless Light`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Fight the Contorionistes, `}</p>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "3-contorionistes-012"
      }}>{`3 Contorionistes (0:12)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`3163305XP, $27864, Contorso, 3 Lumina, 3 Grandiose`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-34"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Fortune Fury > Skip`}</li>
        <li parentName="ul">{`Maelle: Phantom Strike`}</li>
      </ul>
    </Menu>
    <p>{`Do this menu during the long jump.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-24"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Auto Death`}</li>
            <li parentName="ul">{`+Death Bomb`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`(Triangle) +At Death's Door > Confident Fighter`}</li>
          </ul></li>
        <li parentName="ul">{`Monoco:`}<ul parentName="li">
            <li parentName="ul">{`+Burning Death > Burn Affinity`}</li>
            <li parentName="ul">{`+Confident Fighter > Warming Up`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-17"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Monoco:`}<ul parentName="li">
            <li parentName="ul">{`+Dead Energy II`}</li>
            <li parentName="ul">{`+Critical Moment`}</li>
            <li parentName="ul">{`+Energising Start I`}</li>
            <li parentName="ul">{`+Energising Start III`}</li>
            <li parentName="ul">{`+Glass Canon`}</li>
            <li parentName="ul">{`+Painted Power`}</li>
            <li parentName="ul">{`+Warming Up`}</li>
            <li parentName="ul">{`+Teamwork`}</li>
            <li parentName="ul">{`+Immaculate`}</li>
            <li parentName="ul">{`+First Offensive`}</li>
            <li parentName="ul">{`+(R2) At Death's Door`}</li>
            <li parentName="ul">{`+Augmented First Strike`}</li>
            <li parentName="ul">{`+Auto Powerful`}</li>
            <li parentName="ul">{`+Burn Affinity`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Burn Affinity`}</li>
            <li parentName="ul">{`+Confident Fighter`}</li>
            <li parentName="ul">{`+Critical Burn`}</li>
            <li parentName="ul"><em parentName="li">{`-`}</em>{`(L2) Cheater`}</li>
          </ul></li>
        <li parentName="ul">{`Verso:`}<ul parentName="li">
            <li parentName="ul">{`+Burning Death`}</li>
            <li parentName="ul">{`+Confident Fighter`}</li>
            <li parentName="ul">{`+(R2, Up) Teamwork`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "simon-p1-010"
      }}>{`Simon P1 (0:10)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1485000XP, $25220`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-35"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Intervention Maelle`}</li>
        <li parentName="ul">{`Maelle: Stendhal`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h4 {...{
        "id": "simon-p2-017"
      }}>{`Simon P2 (0:17)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`1237500XP (NB), $25220,`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-0-36"
      }}>{`Turn 0`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Fortune Fury Maelle > Marking Card`}</li>
        <li parentName="ul">{`Maelle: Stendhal`}</li>
      </ul>
    </Menu>
    <p>{`Go to flag, Back to Continent.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-14"
      }}>{`Formation`}</h5>
      <p>{`-Sciel, +Verso`}</p>
      <h5 {...{
        "id": "weapons-5"
      }}>{`Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Verso: Simoso`}</li>
        <li parentName="ul">{`Monoco: Joyaro`}</li>
      </ul>
    </Menu>
    <p>{`Go to `}<strong parentName="p">{`Sacred River`}</strong>{`.`}</p>
    <h3 {...{
      "id": "sacred-river"
    }}>{`Sacred River`}</h3>
    <p>{`Left at fork.`}<br parentName="p"></br>{`
`}{`Golgra: Duallist Storm (0:06, $13070, 648000XP, 3 Grandiose)`}<br parentName="p"></br>{`
`}{`Backtrack to exit.`}</p>
    <h3 {...{
      "id": "camp-8"
    }}>{`Camp`}</h3>
    <p>{`Talk to Monoco for Relationship 7.`}<br parentName="p"></br>{`
`}{`Get Sciel to Relationship 7.`}<br parentName="p"></br>{`
`}{`Go to sleep.`}</p>
    <h3 {...{
      "id": "continent-35"
    }}>{`Continent`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Children of Lumiere`}</strong>{` from Merchant.`}<br parentName="p"></br>{`
`}{`Go to island above Endless Tower, get `}<strong parentName="p">{`Lost Gestral (9/9)`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to Endless Tower.`}</p>
    <h3 {...{
      "id": "endless-tower"
    }}>{`Endless Tower`}</h3>
    <p>{`Battle notes will be shorter than usual here, considering how many fights there are.`}</p>
    <Menu mdxType="Menu">
      <ul>
        <li parentName="ul"><strong parentName="li">{`1-1`}</strong>{`: Death Bomb`}</li>
        <li parentName="ul"><strong parentName="li">{`1-2`}</strong>{`: Shoot Cultist`}</li>
        <li parentName="ul"><strong parentName="li">{`1-3`}</strong>{`: Stendhal`}</li>
        <li parentName="ul"><strong parentName="li">{`2-1`}</strong>{`: Death Bomb`}</li>
        <li parentName="ul"><strong parentName="li">{`2-2`}</strong>{`: Skip Turn`}</li>
        <li parentName="ul"><strong parentName="li">{`2-3`}</strong>{`: Shoot Echassier, Stendhal`}</li>
        <li parentName="ul"><strong parentName="li">{`3-1`}</strong>{`: Phantom Strike`}</li>
        <li parentName="ul"><strong parentName="li">{`3-2`}</strong>{`: Last Chance > Phantom Strike`}</li>
      </ul>
    </Menu>
    <blockquote>
      <p parentName="blockquote">{`This might need to be delayed until after 3-3 due to being 1 Grandiose short. After 4-3 should be completely safe. Only unsure of 4 Goblu non-crits killing (1/256 chance)`}</p>
    </blockquote>
    <p>{`Go to flag.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "upgrade-weapons-8"
      }}>{`Upgrade Weapons`}</h5>
      <ul>
        <li parentName="ul">{`Monoco: Joyaro +5 (33)`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <ul>
        <li parentName="ul"><strong parentName="li">{`3-3`}</strong>{`: Shoot Abbest Weak Point, Phantom Strike > Duallist Storm`}</li>
        <li parentName="ul"><strong parentName="li">{`4-1`}</strong>{`: Shoot Cruler 4 times, Stendhal`}</li>
        <li parentName="ul"><strong parentName="li">{`4-2`}</strong>{`: Stendhal`}</li>
        <li parentName="ul"><strong parentName="li">{`4-3`}</strong>{`: Stendhal, Chalier Combo (FAIL QTE)`}</li>
        <li parentName="ul"><strong parentName="li">{`5-1`}</strong>{`: Stendhal`}</li>
        <li parentName="ul"><strong parentName="li">{`5-2`}</strong>{`: Stendhal`}</li>
        <li parentName="ul"><strong parentName="li">{`5-3`}</strong>{`: Stendhal, Duallist Storm`}</li>
      </ul>
    </Menu>
    <p>{`Menu here (must be done before 6-2).`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "pictos-25"
      }}>{`Pictos`}</h5>
      <ul>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Greater Defenceless > Energising Attack`}</li>
          </ul></li>
        <li parentName="ul">{`Monoco:`}<ul parentName="li">
            <li parentName="ul">{`+Charging Critical > Energy Master`}</li>
          </ul></li>
      </ul>
      <h5 {...{
        "id": "lumina-18"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Monoco:`}<ul parentName="li">
            <li parentName="ul">{`+(L2) Energy Master`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <ul>
        <li parentName="ul"><strong parentName="li">{`6-1`}</strong>{`: Shoot Stalact x2, Phantom Strikes > Shoot Stalact`}</li>
        <li parentName="ul"><strong parentName="li">{`6-2`}</strong>{`: Shoot Glaise x5, Stendhal`}</li>
        <li parentName="ul"><strong parentName="li">{`6-3`}</strong>{`: Stendhal, Lampmaster Light`}</li>
        <li parentName="ul"><strong parentName="li">{`7-1`}</strong>{`: Stendhal`}</li>
        <li parentName="ul"><strong parentName="li">{`7-2`}</strong>{`: Shoot Bruler weakpoint, Guard Down, Lampmaster Light`}</li>
        <li parentName="ul"><strong parentName="li">{`7-3`}</strong>{`: Stendhal, Duallist Storm`}</li>
      </ul>
    </Menu>
    <p>{`After 7-3, Menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "skills"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Sciel:`}<ul parentName="li">
            <li parentName="ul">{`+Our Sacrifice > Focused Foretell`}</li>
          </ul></li>
        <li parentName="ul">{`Monoco:`}<ul parentName="li">
            <li parentName="ul">{`+(1D) Echassier Stabs > Stalact Punches`}</li>
            <li parentName="ul">{`+(1D) Sakapatate Fire > Sakapatate Estoc`}</li>
          </ul></li>
        <li parentName="ul">{`Maelle:`}<ul parentName="li">
            <li parentName="ul">{`+Degagement > Mezzo Forte`}</li>
          </ul></li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <ul>
        <li parentName="ul"><strong parentName="li">{`8-1`}</strong>{`: Shoot Francois x3, Robust x2, Skip, Sakapatate Fire`}</li>
        <li parentName="ul"><strong parentName="li">{`8-2`}</strong>{`: Shoot Bouchelier x6, Energy Tint Monoco, Sakapatate Fire`}</li>
        <li parentName="ul"><strong parentName="li">{`8-3`}</strong>{`: Shoot Glaise x6, Skip, Sakapatate Fire`}</li>
        <li parentName="ul"><strong parentName="li">{`9-1`}</strong>{`: Last Chance > Shoot Ballet Head x5, Shoot Braseleur x4, Stendhal`}</li>
        <li parentName="ul"><strong parentName="li">{`9-2`}</strong>{`: Shoot Mine x2, Shoot Stalact x3, Degagement, Sakapatate Fire`}</li>
      </ul>
    </Menu>
    <p>{`After 9-2, Menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-15"
      }}>{`Formation`}</h5>
      <p>{`-Verso, +Sciel`}</p>
    </Menu>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "9-3"
      }}>{`9-3`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Stendhal vulnerable Eveque`}</li>
        <li parentName="ul">{`Monoco: Duallist Storm Danseuse`}</li>
        <li parentName="ul">{`Sciel: Intervention Maelle`}</li>
        <li parentName="ul">{`Maelle: Last Chance > Stendhal`}</li>
      </ul>
      <p><strong parentName="p">{`10-1`}</strong>{`: Shoot Mine x3, Shoot Portier x4, Guard Down, Sakapatate Fire`}</p>
    </Menu>
    <p>{`Menu before 10-2.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-16"
      }}>{`Formation`}</h5>
      <p>{`-+Monoco`}</p>
    </Menu>
    <Menu mdxType="Menu">
      <p><strong parentName="p">{`10-2`}</strong>{`: Degagement, Fortune Fury Monoco > Attack, Sakapatate Fire`}<br parentName="p"></br>{`
`}<strong parentName="p">{`10-3`}</strong>{`: Guard Down, Intervention Monoco, Sakapatate Fire`}</p>
    </Menu>
    <p>{`Menu before 11-1`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "lumina-19"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: +(L2, 2 Right) +Cheater`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "11-1"
      }}>{`11-1`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: Stendhal Moisonneusse > Guard Down`}</li>
        <li parentName="ul">{`Sciel: Fortune Fury Monoco > Our Sacrifice`}</li>
        <li parentName="ul">{`Maelle: Degagement Dualliste > Skip`}</li>
        <li parentName="ul">{`Monoco: Sakapatate Fire`}</li>
      </ul>
    </Menu>
    <p>{`Menu before 11-2`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "formation-17"
      }}>{`Formation`}</h5>
      <p>{`-+Maelle`}</p>
      <h5 {...{
        "id": "lumina-20"
      }}>{`Lumina`}</h5>
      <ul>
        <li parentName="ul">{`Maelle: -(R3,L2) Shortcut`}</li>
      </ul>
    </Menu>
    <Menu mdxType="Menu">
      <p><strong parentName="p">{`11-2`}</strong>{`: Fortune Fury Monoco > Our Sacrifice, Sakapatate Fire, Attack`}</p>
      <h5 {...{
        "id": "11-3"
      }}>{`11-3`}</h5>
      <ul>
        <li parentName="ul">{`Sciel: Fortune Fury `}<strong parentName="li">{`Maelle`}</strong>{` > Our Sacrifice`}</li>
        <li parentName="ul">{`Monoco: Echassier Stabs`}</li>
        <li parentName="ul">{`Maelle: Stendhal`}</li>
      </ul>
    </Menu>
    <p>{`Should be final achievements, GG!`}</p>
    <h2 {...{
      "id": "archive"
    }}>{`Archive`}</h2>
    <Menu mdxType="Menu">
      <p>{`Swag Painted Love Strat (no extra menu required, 34s fight)`}</p>
      <ul>
        <li parentName="ul">{`Maelle: Degagement > Skip`}</li>
        <li parentName="ul">{`Sciel: Fortune Fury Monoco > Our Sacrifice`}</li>
        <li parentName="ul">{`Maelle: Guard Down > Degagement Other`}</li>
        <li parentName="ul">{`Monoco: Sakapatate Fire`}</li>
      </ul>
      <p>{`The current 11-3 can be improved by 2s by giving Monoco Echassier Stabs, or 3s by getting Verso in, removing auto-death, and using Defiant Strike`}</p>
    </Menu>
    <h2 {...{
      "id": "timings"
    }}>{`Timings`}</h2>
    <h3 {...{
      "id": "spring-meadows-1"
    }}>{`Spring Meadows`}</h3>
    <p>{`The $720 chroma detour takes 11.5s.`}<br parentName="p"></br>{`
`}{`Empowering Attack Picto is ~15s detour after Eveque.`}</p>
    <h3 {...{
      "id": "flying-waters-2"
    }}>{`Flying Waters`}</h3>
    <p>{`The Bruler than jumps down after Manor can be done pretty quick. $466, 1340XP, Bruleram.`}<br parentName="p"></br>{`
`}{`The Bruler + Crueler fight gives 1069XP $400`}<br parentName="p"></br>{`
`}{`Money pickups after tunnel cost ~6.5s for $990`}</p>
    <h3 {...{
      "id": "esquies-nest-1"
    }}>{`Esquie's Nest`}</h3>
    <p>{`Backtracking after Francois is 12s faster, but loses $1305 and Colour of Lumina.`}<br parentName="p"></br>{`
`}{`Flagging after Esquie saves ~13s, but loses Energising Start III.`}</p>
    <h3 {...{
      "id": "visages-1"
    }}>{`Visages`}</h3>
    <p>{`Killing self with Wildfire + Perfect Recovery > Flee: `}{`~`}{`14.5s`}<br parentName="p"></br>{`
`}{`Killing self with Wildfire + Perfect Recovery > 2nd party: `}{`~`}{`21s`}<br parentName="p"></br>{`
`}{`Killing self with 2 Moisonneusse (2 short combo) > `}{`~`}{`34s`}</p>
    <h3 {...{
      "id": "sirene-1"
    }}>{`Sirene`}</h3>
    <p>{`Standard Wildfire Ballet death: 29s`}<br parentName="p"></br>{`
`}{`Enemies before Glissando: 32s`}</p>
    <h3 {...{
      "id": "other"
    }}>{`Other`}</h3>
    <p>{`Upgrading Healing Tint when near curator: 4s`}</p>
    <h2 {...{
      "id": "scribbles"
    }}>{`Scribbles`}</h2>
    <h3 {...{
      "id": "optimizations"
    }}>{`Optimizations`}</h3>
    <p>{`To menu during a cutscene load, open menu RIGHT before you cross the cutscene threshold`}<br parentName="p"></br>{`
`}{`Possible optimizations:`}</p>
    <ul>
      <li parentName="ul">{`Before Portier / Lancelier: Remove Lumiere Assault, then learn Powerful first later. It will go into slot 1.`}</li>
      <li parentName="ul">{`Journal 81: Equip Lanceram`}</li>
      <li parentName="ul">{`Before Eveque: Equip Lighterim`}</li>
      <li parentName="ul">{`Flying Waters entrance / manor: Remove Gustave Pictos`}</li>
      <li parentName="ul">{`Maelle room: Equip Maelle pictos.`}</li>
    </ul>
    <h3 {...{
      "id": "todo"
    }}>{`TODO`}</h3>
    <p>{`Better Esoteric Ruins path (can check Doc's last run)`}</p>
    <h3 {...{
      "id": "contorso-vs-simoso-endless-tower"
    }}>{`Contorso vs Simoso Endless Tower`}</h3>
    <p>{`1-2: Simoso -2s`}<br parentName="p"></br>{`
`}{`3-1: Simoso -2s`}<br parentName="p"></br>{`
`}{`3-2: Simoso -3s`}<br parentName="p"></br>{`
`}{`6-1: Simoso +4`}<br parentName="p"></br>{`
`}{`6-2: Simoso +4`}<br parentName="p"></br>{`
`}{`8-1: Simoso +.5`}</p>
    <p>{`Total: Simoso loses 8s, saves 8.5s.`}<br parentName="p"></br>{`
`}{`Simoso currently wins`}</p>
    <h2 {...{
      "id": "changelog"
    }}>{`Changelog`}</h2>
    <h5 {...{
      "id": "90225"
    }}>{`9/02/25`}</h5>
    <ul>
      <li parentName="ul">{`Remove Old Lumiere Manor Gardens flag tag.`}</li>
      <li parentName="ul">{`Re-enter Old Lumiere after Renoir to get J42 and $4990`}</li>
      <li parentName="ul">{`Get Sciel to LV3 Relationship in Visages. Less dialogue.`}</li>
      <li parentName="ul">{`Pathing changes in Act 3!`}</li>
      <li parentName="ul">{`Act 3 Part 1 now gets Goblu, skips J62, SWC visit, Endless Lost Gestral gotten at end of run`}</li>
      <li parentName="ul">{`Lune Lumina for Death Bomb done on Gestral Beach - Only Up fall (+Maelle Teamwork)`}</li>
      <li parentName="ul">{`Menu timings adjusted Sprong > Lampmaster`}</li>
      <li parentName="ul">{`New pathing after Fountain: J62, SWC (Gustave, Hexga), Lost Gestral, SWC Cave`}</li>
      <li parentName="ul">{`Weapon Upgrade now required in White Sands, Gross Tete is now Attack > Stendhal`}</li>
    </ul>
    <h5 {...{
      "id": "90125"
    }}>{`9/01/25`}</h5>
    <ul>
      <li parentName="ul">{`Remove first SWC Lumina from notes (was already cut from route)`}</li>
      <li parentName="ul">{`Remove Any%/Simon% relic recoat stuff in Old Lumiere`}</li>
      <li parentName="ul">{`Use Lumina in Floating Cemetary instead of Falling Leaves`}</li>
      <li parentName="ul">{`Added Gestral Beach - Only Up missing from notes.`}</li>
      <li parentName="ul">{`Sciel uses Ramasson instead of Scielson`}</li>
      <li parentName="ul">{`Flag after Clea changed. DO NOT REST. Also max Monoco Agility (doesn't matter, just less menuing)`}</li>
      <li parentName="ul">{`Change formation before Chromatic Danseuse fight`}</li>
      <li parentName="ul">{`Improved Chromatic Danseuse fight`}</li>
      <li parentName="ul">{`Added note that Monoco's weapon upgrade might need to be done after 3-3. Not sure where Grandiose discrepancy is coming from`}</li>
      <li parentName="ul">{`Removed some old Skip turns from Endless Tower fight notes`}</li>
    </ul>
    <h5 {...{
      "id": "83125"
    }}>{`8/31/25`}</h5>
    <ul>
      <li parentName="ul">{`Pre Simon menu adjusted, now remove Cheater from Maelle`}</li>
      <li parentName="ul">{`Endless Tower fights optimized, save ~30s. The changed fights are:`}<ul parentName="li">
          <li parentName="ul">{`3-3`}</li>
          <li parentName="ul">{`4-3`}</li>
          <li parentName="ul">{`5-3`}</li>
          <li parentName="ul">{`7-2`}</li>
          <li parentName="ul">{`8-1`}</li>
          <li parentName="ul">{`9-3`}</li>
          <li parentName="ul">{`10-1`}</li>
          <li parentName="ul">{`10-2`}</li>
        </ul></li>
      <li parentName="ul">{`The menu timings in Endless were also adjusted, and some additional menuing was added`}</li>
    </ul>
    <h5 {...{
      "id": "83025"
    }}>{`8/30/25`}</h5>
    <ul>
      <li parentName="ul">{`Cut Lumina in Monoco Station`}</li>
      <li parentName="ul">{`Add note to buy Recoat in Monolith Flying Waters if not owned`}</li>
      <li parentName="ul">{`Moved Act 3 Lumiere menus around`}</li>
      <li parentName="ul">{`Verso gets Delaram for Renoir 3, cut his attack on Renoir 3`}</li>
      <li parentName="ul">{`Cut 3 Lumina pickups in Lumiere`}</li>
      <li parentName="ul">{`Renoir 3 Stendhal is 1.3 now`}</li>
      <li parentName="ul">{`Adjusted pathing after Gustave, Blades Graveyard, Journals, Painting Workshop, Gestral Beach after Sprong now.`}</li>
      <li parentName="ul">{`No more Chromatic Elixer for Chromatic Demineur`}</li>
      <li parentName="ul">{`Adjusted menu before Sprong`}</li>
      <li parentName="ul">{`Adjusted menu in Flying Manor (Monoco gets Warming Up)`}</li>
      <li parentName="ul">{`Adjusted menu during Simon jump (Monoco gets Confident Fighter over Warming Up)`}</li>
    </ul>
    <h5 {...{
      "id": "82425"
    }}>{`8/24/25`}</h5>
    <ul>
      <li parentName="ul">{`Faster Mime strat`}</li>
      <li parentName="ul">{`Added missing Monoco Inverted equip in Old Lumiere`}</li>
      <li parentName="ul">{`Fixed Abberation name in Act 3 Lumiere`}</li>
      <li parentName="ul">{`Split up menus during Sprong > Chromatic Glissando so we can do most during jumps`}</li>
      <li parentName="ul">{`Added note for Sciel Relationship 7 after Sacred River`}</li>
    </ul>
    <h5 {...{
      "id": "82025"
    }}>{`8/20/25`}</h5>
    <ul>
      <li parentName="ul">{`Change in pre-Simon menu, Maelle no longer gets Burning Death and gets Critical Burn Lumina. Critical Burn gets her to 100% crit since Verso has Burning Death`}</li>
      <li parentName="ul">{`Monoco now gets Burning Death picto and Burn Affinity Lumina in the pre-Simon menu`}</li>
    </ul>
    <h5 {...{
      "id": "81525"
    }}>{`8/15/25`}</h5>
    <ul>
      <li parentName="ul">{`Minor fixes for notes, route unchanged.`}</li>
      <li parentName="ul">{`Frozen Hearts pathing adjusted.`}</li>
    </ul>
    <h5 {...{
      "id": "81425"
    }}>{`8/14/25`}</h5>
    <ul>
      <li parentName="ul">{`Faster EXP farm, kill 36 Danseuse instead of 40.`}</li>
      <li parentName="ul">{`Shortened notes on Danseuse farm, since we loop the same stuff for longer now`}</li>
      <li parentName="ul">{`Adjusted 4-3, 6-1, and 10-1 in Endless Tower for lower stats from lower EXP.`}</li>
    </ul>
    <h5 {...{
      "id": "81325"
    }}>{`8/13/25`}</h5>
    <ul>
      <li parentName="ul">{`Added note to pick up recoat in Flying Waters`}</li>
      <li parentName="ul">{`Added fall strat to Monoco Station`}</li>
      <li parentName="ul">{`Added T1 Verso Attack to Mask Keeper, like to be short on damage otherwise`}</li>
      <li parentName="ul">{`Do Maelle Relationship up to LV4 in Camp after Mask Keeper (less dialogue)`}</li>
      <li parentName="ul">{`Fix Flying Waters Polished purchase count`}</li>
      <li parentName="ul">{`Upgrade Lumina in Camp before A3 Lumiere. Allows menuing on jump.`}</li>
      <li parentName="ul">{`Update Lumina count in Yellow Harvest`}</li>
      <li parentName="ul">{`Proper Lumina count in Flying Casino`}</li>
      <li parentName="ul">{`Change 11-2 in Endless Tower, do menu before 11-2 now.`}</li>
    </ul>
    <h5 {...{
      "id": "81225"
    }}>{`8/12/25`}</h5>
    <p>{`First "upload ready" route. Changelog will start getting logged from here.`}</p>
    <h5 {...{
      "id": "81125"
    }}>{`8/11/25`}</h5>
    <p>{`"Finished" Route`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      